<template>
  <div class="bill-info">
    <KTCodePreview v-bind:title="''">
      <template v-slot:preview>
        <b-card no-body class="full-width">
          <div>
            <div class="wizard-nav-bg">
              <b-col
                class="py-2"
                cols="12"
                style="border-bottom: 0.5px solid #e7e7e7"
              >
                <b-row>
                  <b-col
                    ><b>{{ pageTitle ? pageTitle : '#' }}</b>
                  </b-col>
                  <!-- <b-col>
					  <div class="d-flex justify-content-end mr-3">
						<template v-if="shiftWorkConfig">
						  <b-button-group
							v-if="shiftWorkConfig && mainModel.editable"
							class="font-weight-bold ml-3"
						  >
							<b-button
							  v-b-tooltip.hover
							  title="Chọn nhân viên theo cấu hình theo ca làm việc"
							  @click="onShiftWorkConfigSelected"
							  >{{ shiftWorkConfig.name }}
							</b-button>
							<b-button
							  @click="showModalShiftWorkConfig"
							  v-b-modal.modal-upsert-shiftWork
							>
							  <i class="fa fa-cog font-size-md"></i>
							</b-button>
						  </b-button-group>
						</template>
						<b-button
						  v-else
						  @click="showModalShiftWorkConfig"
						  v-b-modal.modal-upsert-shiftWork
						>
						  Cấu hình ca làm việc
						</b-button>
					  </div>
					</b-col> -->
                </b-row>
              </b-col>
            </div>
            <div
              class="wizard wizard-4"
              id="kt_wizard_v4_bill"
              data-wizard-state="step-first"
              data-wizard-clickable="true"
            >
              <!--begin: Wizard Nav-->
              <div class="wizard-nav wizard-nav-bg" style="border-radius: 0px">
                <div class="wizard-steps">
                  <!-- Thông tin -->
                  <div
                    class="wizard-step"
                    data-wizard-type="step"
                    data-wizard-state="current"
                  >
                    <div class="wizard-wrapper p-2">
                      <div class="wizard-label">
                        <div class="wizard-title">Thông tin</div>
                      </div>
                    </div>
                  </div>
                  <!-- Lịch sử -->
                  <div
                    class="wizard-step ml-1"
                    data-wizard-type="step"
                    v-show="mainModel.id"
                  >
                    <div class="wizard-wrapper p-2">
                      <div class="wizard-label">
                        <div class="wizard-title">Lịch sử</div>
                      </div>
                    </div>
                  </div>
                  <!-- Tệp đính kèm -->
                  <div
                    class="wizard-step ml-1"
                    data-wizard-type="step"
                    v-show="mainModel.id"
                  >
                    <div class="wizard-wrapper p-2">
                      <div class="wizard-label">
                        <div class="wizard-title">Tệp đính kèm</div>
                      </div>
                    </div>
                  </div>
                  <!-- Phiếu thu cũ -->
                  <!-- <div class="wizard-step ml-1" data-wizard-type="step">
					  <div class="wizard-wrapper p-2">
						<div class="wizard-label">
						  <div class="wizard-title">Phiếu thu cũ</div>
						</div>
					  </div>
					</div> -->
                </div>
              </div>
              <div class="card card-custom card-shadowless rounded-top-0">
                <b-skeleton-wrapper :loading="!renderComponent">
                  <template #loading>
                    <div class="card-body">
                      <b-row>
                        <b-col md="9">
                          <div class="mb-4 d-flex d-inline">
                            <b-skeleton
                              animation="wave"
                              width="18%"
                              class="mr-2"
                            ></b-skeleton>
                            <b-skeleton
                              animation="wave"
                              width="82%"
                            ></b-skeleton>
                          </div>
                          <b-skeleton-table
                            :rows="4"
                            :columns="4"
                            :table-props="{ bordered: true, striped: true }"
                          ></b-skeleton-table>
                          <b-row>
                            <b-col md="4">
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                            </b-col>
                            <b-col md="4">
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                            </b-col>
                            <b-col md="4">
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col md="3">
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton>
                          <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton>
                        </b-col>
                      </b-row>
                    </div>
                  </template>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-xl-12">
                        <div
                          class="py-4 mb-5 full-width"
                          data-wizard-type="step-content"
                          data-wizard-state="current"
                        >
                          <b-form ref="form" lazy-validation class="row">
                            <!-- VAT invoice status -->
                            <b-row
                              class="col-md-12 mb-2 m-0 p-0"
                              v-if="mainModel.vatStatus"
                            >
                              <span class="bvat-pill" :class="vatPillClass">
                                <i class="fas fa-file-invoice-dollar"></i>
                                {{ vatStatusLabel }}
                              </span>
                              <span
                                v-if="
                                  mainModel.vatStatus === 'NOT_ISSUED' &&
                                  mainModel.vatRejectReason
                                "
                                class="bvat-reject-note ml-3"
                              >
                                Lý do từ chối gần nhất:
                                {{ mainModel.vatRejectReason }}
                              </span>
                            </b-row>
                            <b-row
                              class="col-md-12 mb-1 m-0 p-0"
                              v-if="
                                mainModel.vatStatus === 'REQUESTED' ||
                                mainModel.vatStatus === 'ISSUED'
                              "
                            >
                              <div
                                class="alert alert-dismissible bg-light-danger"
                                style="width: 100%"
                              >
                                Hóa đơn đang
                                <strong>{{ vatStatusLabel }}</strong
                                >, trường hợp cần chỉnh sửa
                                <strong>vui lòng liên hệ kế toán</strong>
                              </div>
                            </b-row>
                            <b-row
                              class="col-md-12 mb-1 m-0 p-0"
                              v-if="mainModel.fromBillNumber"
                            >
                              <div class="alert-header" style="width: 100%">
                                Tạo lại hóa đơn mới từ hóa đơn:
                                <span class="text-primary">{{
                                  mainModel.fromBillNumber
                                }}</span>
                              </div>
                            </b-row>
                            <b-row
                              class="col-md-12 mb-1 m-0 p-0"
                              v-if="mainModel.orderId"
                            >
                              <div class="alert-header" style="width: 100%">
                                Chuyển đơn hàng
                                <span
                                  class="text-primary"
                                  style="cursor: pointer"
                                  @click="linkToOrder(mainModel.orderId)"
                                  >{{ mainModel.orderId }}</span
                                >
                                sang hóa đơn bán lẻ .
                                <ul
                                  style="
                                    padding-left: 15px;
                                    line-height: 20px;
                                    margin-top: 5px;
                                    list-style: circle;
                                  "
                                >
                                  <li v-show="mainModel.moneyPaid > 0">
                                    Số tiền đã đặt cọc:
                                    <span class="text-primary">
                                      {{ formatMoney(mainModel.moneyPaid) }}
                                    </span>
                                  </li>
                                  <li v-show="mainModel.moneyTransfered > 0">
                                    Số tiền đã chuyển khoản:
                                    <span class="text-primary">
                                      {{
                                        formatMoney(mainModel.moneyTransfered)
                                      }}
                                    </span>
                                  </li>
                                  <li v-show="mainModel.moneyCredit > 0">
                                    Số tiền quẹt thẻ:
                                    <span class="text-primary">
                                      {{ formatMoney(mainModel.moneyCredit) }}
                                    </span>
                                  </li>
                                  <li v-show="mainModel.moneyInstallment > 0">
                                    Số tiền đã trả góp:
                                    <span class="text-primary">
                                      {{
                                        formatMoney(mainModel.moneyInstallment)
                                      }}
                                    </span>
                                  </li>
                                  <li v-show="mainModel.customerShipFee > 0">
                                    Phí ship:
                                    <span class="text-primary">
                                      {{
                                        formatMoney(mainModel.customerShipFee)
                                      }}
                                    </span>
                                  </li>
                                </ul>
                                Mã vận đơn:
                                <span class="text-primary">
                                  {{ mainModel.codeShip }}
                                </span>
                              </div>
                            </b-row>
                            <b-row
                              class="col-md-12 mb-1 m-0 p-0"
                              v-if="mainModel.contractNumber"
                            >
                              <div class="alert-header" style="width: 100%">
                                Chuyển từ hợp đồng mua bán
                                <span
                                  class="text-primary"
                                  style="cursor: pointer"
                                  @click="linkToContract(mainModel.contractId)"
                                  >{{ mainModel.contractNumber }}</span
                                >
                                sang hóa đơn bán lẻ .
                                <ul
                                  style="
                                    padding-left: 15px;
                                    line-height: 20px;
                                    margin-top: 5px;
                                    list-style: circle;
                                  "
                                >
                                  <li
                                    v-show="mainModel.moneyPrepaidContract > 0"
                                  >
                                    Tổng đã thanh toán trên HĐ (đối trừ vào
                                    Khách cần trả):
                                    <span class="text-primary">
                                      {{
                                        formatMoney(
                                          mainModel.moneyPrepaidContract,
                                        )
                                      }}
                                    </span>
                                  </li>
                                  <li v-show="mainModel.moneyPaid > 0">
                                    Tổng tiền mặt đã thanh toán:
                                    <span class="text-primary">
                                      {{ formatMoney(mainModel.moneyPaid) }}
                                    </span>
                                  </li>
                                  <li v-show="mainModel.moneyTransfered > 0">
                                    Tổng tiền chuyển khoản đã thanh toán:
                                    <span class="text-primary">
                                      {{
                                        formatMoney(mainModel.moneyTransfered)
                                      }}
                                    </span>
                                  </li>
                                  <li v-show="mainModel.moneyCredit > 0">
                                    Tổng tiền quẹt thẻ đã thanh toán:
                                    <span class="text-primary">
                                      {{ formatMoney(mainModel.moneyCredit) }}
                                    </span>
                                  </li>
                                  <li v-show="mainModel.moneyInstallment > 0">
                                    Số tiền đã trả góp:
                                    <span class="text-primary">
                                      {{
                                        formatMoney(mainModel.moneyInstallment)
                                      }}
                                    </span>
                                  </li>
                                  <li v-show="mainModel.customerShipFee > 0">
                                    Phí ship:
                                    <span class="text-primary">
                                      {{
                                        formatMoney(mainModel.customerShipFee)
                                      }}
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </b-row>
                            <b-row
                              class="col-md-12 mb-1 m-0 p-0"
                              v-if="
                                !mainModel.id &&
                                !mainModel.orderId &&
                                orderNotComplete
                              "
                            >
                              <div class="alert-header" style="width: 100%">
                                Khách hàng đang có đơn hàng chưa hoàn tất:
                                <span class="text-primary"
                                  >#{{ orderNotComplete.id }}</span
                                >
                                -
                                <span
                                  v-text="orderNotComplete.statusName"
                                  class="text-warning"
                                ></span>
                              </div>
                            </b-row>
                            <b-row
                              class="col-md-12 mb-1 m-0 p-0"
                              v-if="getInstallmentInterestZero"
                            >
                              <div class="alert-header" style="width: 100%">
                                <i
                                  class="fa fa-exclamation-triangle text-warning"
                                ></i>
                                <strong class="text-dark">
                                  Chuyển sang cấu hình trả góp 0%</strong
                                >
                                <span
                                  class="text-primary ml-2"
                                  style="cursor: pointer"
                                  @click="onShowInterestProgram"
                                  >Xem chương trình</span
                                >
                              </div>
                            </b-row>
                            <b-row class="col-md-12 mb-1 m-0 p-0">
                              <b-col md="9" class="mb-2">
                                <b-row>
                                  <b-col md="3" class="p-0">
                                    <b-form-select
                                      v-model="selectTypeSearch"
                                      class="select-style"
                                      :options="listTypeSearch"
                                      size="sm"
                                      value-field="id"
                                      text-field="name"
                                      @change="changePlaceholder"
                                    ></b-form-select>
                                  </b-col>
                                  <b-col md="9" class="p-0">
                                    <vue-autosuggest
                                      v-model="searchProduct"
                                      :suggestions="filteredOptionsProduct"
                                      @selected="onSelectedProduct"
                                      :limit="20"
                                      @input="onInputChangProduct"
                                      :input-props="inputSearchProductProp"
                                      :should-render-suggestions="
                                        (size, loading) => !loading
                                      "
                                      :get-suggestion-value="
                                        (suggestion) =>
                                          suggestion.item.productName
                                      "
                                    >
                                      <div
                                        v-if="
                                          selectTypeSearch ===
                                          PRODUCT_SEARCH_TYPE.PRODUCT_NAME
                                        "
                                        slot-scope="{ suggestion }"
                                        style="
                                          display: flex;
                                          align-items: center;
                                        "
                                      >
                                        <div>
                                          <span
                                            v-if="getInstallmentInterestZero"
                                            class="text-warning"
                                          >
                                            (
                                            {{
                                              formatMoney(
                                                suggestion.item.listedPrice,
                                              )
                                            }}
                                            )</span
                                          >
                                          <span v-else class="text-primary"
                                            >({{
                                              formatMoney(
                                                suggestion.item.sellingPrice,
                                              )
                                            }})
                                          </span>
                                          <span
                                            v-if="
                                              suggestion.item.quantityInStock >
                                                0 &&
                                              suggestion.item.productType !==
                                                PRODUCT_TYPE_ENUM.SERVICE
                                            "
                                            class="text-success"
                                            >(Tồn CTB:
                                            {{
                                              suggestion.item.quantityInStock
                                            }})</span
                                          >

                                          {{ suggestion.item.productName }}
                                        </div>
                                      </div>
                                      <!-- <div
                                        v-else-if="selectTypeSearch === 2"
                                        slot-scope="{ suggestion }"
                                        style="
                                          display: flex;
                                          align-items: center;
                                        "
                                      >
                                        <div>
                                          <span class="text-primary"
                                            >({{
                                              formatMoney(
                                                suggestion.item.sellingPrice,
                                              )
                                            }})</span
                                          >
                                          <span
                                            v-if="
                                              suggestion.item.quantityInStock >
                                              0
                                            "
                                            class="text-success"
                                            >(Tồn CTB:
                                            {{
                                              suggestion.item.quantityInStock
                                            }})</span
                                          >
                                          {{ suggestion.item.productName }}-
                                          <span class="text-warning"
                                            >IMEI:
                                            {{ suggestion.item.imeiCode }}</span
                                          >
                                        </div>
                                      </div>
                                      <div
                                        v-else-if="selectTypeSearch === 3"
                                        slot-scope="{ suggestion }"
                                        style="
                                          display: flex;
                                          align-items: center;
                                        "
                                      >
                                        <div>
                                          <span class="text-success"
                                            >(Số SP:
                                            {{
                                              suggestion.item.listItem.length
                                            }})</span
                                          >
                                          {{ suggestion.item.productName }}
                                        </div>
                                      </div> -->
                                      <div
                                        v-else-if="
                                          selectTypeSearch ===
                                          PRODUCT_SEARCH_TYPE.CHASSIS_ENGINE
                                        "
                                        slot-scope="{ suggestion }"
                                        style="
                                          display: flex;
                                          align-items: center;
                                        "
                                      >
                                        <div>
                                          <span class="text-primary"
                                            >({{
                                              formatMoney(
                                                suggestion.item.sellingPrice,
                                              )
                                            }})</span
                                          >
                                          <span
                                            v-if="
                                              suggestion.item.quantityInStock >
                                              0
                                            "
                                            class="text-success"
                                            >(Tồn CTB:
                                            {{
                                              suggestion.item.quantityInStock
                                            }})</span
                                          >
                                          {{ suggestion.item.productName }} -
                                          <span class="text-warning">
                                            (SK:
                                            {{
                                              suggestion.item?.productChassis
                                                ?.chassisNumber || ''
                                            }}, SM:
                                            {{
                                              suggestion.item?.productChassis
                                                ?.engineNumber || ''
                                            }})
                                          </span>
                                        </div>
                                      </div>
                                      <div
                                        v-else-if="
                                          selectTypeSearch ===
                                          PRODUCT_SEARCH_TYPE.SERIAL
                                        "
                                        slot-scope="{ suggestion }"
                                        style="
                                          display: flex;
                                          align-items: center;
                                        "
                                      >
                                        <div>
                                          <span class="text-primary"
                                            >({{
                                              formatMoney(
                                                suggestion.item.sellingPrice,
                                              )
                                            }})</span
                                          >
                                          <span
                                            v-if="
                                              suggestion.item.quantityInStock >
                                              0
                                            "
                                            class="text-success"
                                            >(Tồn CTB:
                                            {{
                                              suggestion.item.quantityInStock
                                            }})</span
                                          >
                                          {{ suggestion.item.productName }}-
                                          <span class="text-warning"
                                            >Serial:
                                            {{
                                              suggestion.item?.productSeries
                                                ?.serialNumber
                                            }}</span
                                          >
                                        </div>
                                      </div>
                                      <template slot="after-section">
                                        <div
                                          class="p-2 text-center"
                                          v-if="
                                            !filteredOptionsProduct[0].data
                                              .length
                                          "
                                        >
                                          <div v-if="!productLoading">
                                            <img
                                              src="../../../assets/image/no-results.png"
                                            />
                                            <b class="ml-2">Không có kết quả</b>
                                          </div>
                                          <b-spinner
                                            label="Spinning"
                                            v-if="productLoading"
                                          ></b-spinner>
                                        </div>
                                      </template>
                                    </vue-autosuggest>
                                  </b-col>
                                </b-row>
                              </b-col>
                              <b-col md="3" class="mb-3 pr-0">
                                <SearchStore
                                  :onSubmiting="onSubmiting"
                                  :storeId="mainModel.storeId"
                                  :storeName.sync="mainModel.storeName"
                                  v-on:onStoreSelected="onStoreSelected"
                                  :disable="
                                    !!(
                                      mainModel.id ||
                                      mainModel.storeDisable ||
                                      mainModel.contractId
                                    )
                                  "
                                  v-if="renderComponent"
                                />
                              </b-col>
                            </b-row>
                            <b-row class="col-md-12 mb-3 m-0 p-0">
                              <b-col md="9" class="mb-3">
                                <b-row>
                                  <table
                                    class="table table-bordered table-vertical-center table-hover"
                                  >
                                    <thead>
                                      <tr>
                                        <th class="headerTable">STT</th>
                                        <th class="name headerTable">
                                          Sản phẩm
                                        </th>
                                        <th class="value headerTable">SL</th>
                                        <th class="code headerTable">Giá</th>
                                        <th class="code headerTable">
                                          Thành tiền
                                        </th>
                                        <th class="code headerTable">
                                          Chiết khấu
                                        </th>
                                        <th class="code headerTable">VAT</th>
                                        <th></th>
                                      </tr>
                                    </thead>

                                    <tbody
                                      v-for="(mainItem, index) in mainBillItems"
                                      :key="mainItem.id"
                                    >
                                      <BillItem
                                        :productItem="{
                                          ...mainItem,
                                          stt: index + 1,
                                        }"
                                        v-bind:editable="mainModel.editable"
                                        v-bind:productIds="selectedProductIds"
                                        v-bind:editIMEI="
                                          !mainModel.id &&
                                          !mainModel.fromBillNumber
                                        "
                                        v-bind:billItemIndex="index"
                                        v-on:update="updateItem"
                                        v-on:deleteItem="deleteBillItem"
                                        v-on:checkValidImei="checkValidImei"
                                        v-on:addProductBonus="showGiftModal"
                                        v-on:addProductPromotion="
                                          showAttachModal
                                        "
                                        v-on:addProductWarranty="
                                          showWarrantyModal
                                        "
                                        v-on:changeProductBonus="
                                          showChangeGiftModal
                                        "
                                        v-on:addNote="showNoteModal"
                                        v-on:linkToListImei="showListImeiModal"
                                        v-on:linkToListChassisEngine="
                                          showListChassisEngineModal
                                        "
                                        v-on:linkToListSerial="
                                          showListSerialModal
                                        "
                                        v-on:viewInventory="viewInventory"
                                        v-on:addWarranty="linkToWarranty"
                                        v-on:activeImei="showActiveModal"
                                        v-on:addVoucher="showAddVoucherModal"
                                      />

                                      <!-- Related Items -->
                                      <BillItem
                                        v-for="attachItem in getRelatedItems(
                                          mainItem.id,
                                        )"
                                        :key="attachItem.id"
                                        :productItem="attachItem"
                                        v-bind:editable="mainModel.editable"
                                        v-bind:productIds="selectedProductIds"
                                        v-bind:editIMEI="
                                          !mainModel.id &&
                                          !mainModel.fromBillNumber
                                        "
                                        v-bind:billItemIndex="index"
                                        v-on:update="updateItem"
                                        v-on:deleteItem="deleteBillItem"
                                        v-on:checkValidImei="checkValidImei"
                                        v-on:addProductBonus="showGiftModal"
                                        v-on:addProductPromotion="
                                          showAttachModal
                                        "
                                        v-on:addProductWarranty="
                                          showWarrantyModal
                                        "
                                        v-on:changeProductBonus="
                                          showChangeGiftModal
                                        "
                                        v-on:addNote="showNoteModal"
                                        v-on:linkToListImei="showListImeiModal"
                                        v-on:linkToListChassisEngine="
                                          showListChassisEngineModal
                                        "
                                        v-on:linkToListSerial="
                                          showListSerialModal
                                        "
                                        v-on:viewInventory="viewInventory"
                                        v-on:addWarranty="linkToWarranty"
                                        v-on:activeImei="showActiveModal"
                                        v-on:addVoucher="showAddVoucherModal"
                                      />
                                    </tbody>
                                    <tfoot>
                                      <tr>
                                        <th
                                          style="text-align: right"
                                          id="total"
                                          colspan="5"
                                        >
                                          <span
                                            class="d-block"
                                            v-if="totalAmountBeforeDiscount"
                                            >Tổng trước chiết khấu:</span
                                          >
                                          <span class="d-block">Tổng:</span>
                                        </th>
                                        <td
                                          style="
                                            text-align: right;
                                            padding: 0px 20px;
                                          "
                                        >
                                          <span
                                            class="d-block"
                                            v-if="totalAmountBeforeDiscount"
                                          >
                                            {{
                                              formatMoney(
                                                totalAmountBeforeDiscount,
                                              )
                                            }}
                                          </span>
                                          <span class="d-block">{{
                                            formatMoney(totalAmount)
                                          }}</span>
                                        </td>
                                        <td
                                          style="
                                            text-align: right;
                                            padding: 0px 20px;
                                          "
                                        ></td>
                                        <td></td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </b-row>
                                <b-row style="margin-left: -25px">
                                  <b-col :md="mainModel.companyBill ? 4 : 6">
                                    <CustomerInfo
                                      :onSubmiting="onSubmiting"
                                      :billData="mainModel"
                                      :show-customer-type="true"
                                      :disable-customer-type="
                                        !!mainModel.contractId
                                      "
                                      :disabled="!mainModel.editable"
                                      v-on:onUpdate="onUpdateCustomer"
                                      v-if="renderComponent"
                                      v-on:fetch-customer-transaction="
                                        fetchCustomerCransaction
                                      "
                                    />
                                    <!-- <b-form-group
										:disabled="!mainModel.editable"
									  >
										<label>Nguồn khách hàng:</label>
										<b-form-select
										  v-model="mainModel.orderSourceId"
										  :options="listCustomerSource"
										  size="sm"
										  value-field="id"
										  text-field="name"
										  class="select-style"
										>
										  <template v-slot:first>
											<b-form-select-option
											  :value="null"
											  disabled
											  >Chọn nguồn khách hàng:
											</b-form-select-option>
										  </template>
										</b-form-select>
									  </b-form-group> -->
                                  </b-col>
                                  <b-col :md="mainModel.companyBill ? 4 : 6">
                                    <EmployeeInfo
                                      :storeId="mainModel.storeId"
                                      :billDataEmployeeInfo="
                                        mainModel.billEmployeeInfo
                                      "
                                      :disabled="!mainModel.editable"
                                    />
                                  </b-col>
                                  <b-col md="4" v-if="mainModel.companyBill">
                                    <!-- <WarrantyCustomerInfo
										:billData="mainModel"
										:disabled="!mainModel.editable"
										v-if="renderComponent"
									  /> -->
                                    <BillVatInfo
                                      :isValidTaxCode.sync="isValidTaxCode"
                                      :isValidEmail.sync="isValidEmail"
                                      :billData="mainModel"
                                      :disabled="!mainModel.editable"
                                      v-if="renderComponent"
                                    />
                                  </b-col>
                                </b-row>
                                <BillNote
                                  :billNote="mainModel.billNote"
                                  :disabled="!mainModel.editable"
                                  v-if="renderComponent"
                                />
                              </b-col>
                              <b-col md="3" class="mb-3 pr-0">
                                <b-form-group
                                  :disabled="
                                    !mainModel.editable ||
                                    getInstallmentInterestZero
                                  "
                                >
                                  <label class="lable-form">Chiết khấu:</label>
                                  <b-row>
                                    <b-col class="pr-0" cols="3">
                                      <b-form-select
                                        class="select-style"
                                        v-model="mainModel.discountType"
                                        :options="listAmountType"
                                        size="sm"
                                        value-field="id"
                                        text-field="name"
                                      >
                                      </b-form-select>
                                    </b-col>
                                    <b-col class="pl-0" cols="9">
                                      <b-form-input
                                        class="input-style text-right"
                                        size="sm"
                                        v-model="mainModel.discountAmount"
                                        v-mask="mask"
                                        placeholder="Chiết khấu"
                                      ></b-form-input>
                                    </b-col>
                                  </b-row>
                                </b-form-group>

                                <b-form-group :disabled="!mainModel.editable">
                                  <label>Mã coupon:</label>
                                  <b-input-group>
                                    <b-form-input
                                      class="input-style"
                                      size="sm"
                                      type="text"
                                      v-model="mainModel.couponCode"
                                      placeholder="Nhập mã coupon"
                                      @change="changeCouponCode()"
                                      :state="stateCouponCode"
                                    ></b-form-input>
                                    <b-input-group-append>
                                      <b-button
                                        style="width: 40px"
                                        variant="secondary"
                                        size="sm"
                                        @click="checkCoupon()"
                                      >
                                        <i class="fas fa-sync"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                                <div class="row-center-vertical">
                                  <b-col md="6" class="no-side">
                                    <p class="textPayment">Thanh toán</p>
                                  </b-col>
                                  <b-col md="6" class="no-side">
                                    <p
                                      class="textPoint text-right"
                                      v-if="mainModel.isCountPoint"
                                    >
                                      {{ addPoint }} điểm
                                    </p>
                                  </b-col>
                                </div>
                                <b-row class="mb-1">
                                  <b-col md="6">
                                    <span class="textTitlePayment"
                                      >Tổng tiền:</span
                                    >
                                  </b-col>
                                  <b-col md="6" class="text-right">
                                    <span class="textPayment">
                                      {{ formatMoney(totalAmount) }}
                                    </span>
                                  </b-col>
                                </b-row>
                                <b-row
                                  v-if="mainModel.totalAmountPoint > 0"
                                  class="mb-1"
                                >
                                  <b-col md="6">
                                    <span class="textTitlePayment"
                                      >Tiêu điểm:</span
                                    >
                                  </b-col>
                                  <b-col md="6" class="text-right">
                                    <span class="textPayment">
                                      {{
                                        formatMoney(mainModel.totalAmountPoint)
                                      }}
                                    </span>
                                  </b-col>
                                </b-row>
                                <b-row
                                  v-if="totalAmountReturn > 0"
                                  class="mb-1"
                                >
                                  <b-col md="6">
                                    <span class="textTitlePayment">
                                      Tiền thu lại:
                                    </span>
                                  </b-col>
                                  <b-col md="6" class="text-right">
                                    <span class="textPayment">
                                      {{ formatMoney(totalAmountReturn) }}
                                    </span>
                                  </b-col>
                                </b-row>
                                <b-row v-if="totalPaid > 0" class="mb-1">
                                  <b-col md="6">
                                    <span class="textTitlePayment">
                                      Khách trả trước:
                                    </span>
                                  </b-col>
                                  <b-col md="6" class="text-right">
                                    <span class="textPayment">
                                      {{ formatMoney(totalPaid) }}
                                    </span>
                                  </b-col>
                                </b-row>
                                <div v-if="getInstallmentInterestZero">
                                  <b-row>
                                    <b-col md="6">
                                      <b> Tiền trả trước: </b>
                                    </b-col>
                                    <b-col md="6">
                                      <p class="text-right textFinal">
                                        {{ formatMoney(interestZeroPrePaid) }}
                                      </p>
                                    </b-col>
                                  </b-row>
                                  <b-row>
                                    <b-col md="6">
                                      <b> Phí chuyển đổi: </b>
                                    </b-col>
                                    <b-col md="6">
                                      <p class="text-right textFinal">
                                        {{ formatMoney(interestZeroExchange) }}
                                      </p>
                                    </b-col>
                                  </b-row>
                                  <b-row class="mb-1">
                                    <b-col md="6">
                                      <span class="textTitlePayment">
                                        Khách cần trả trước:
                                      </span>
                                    </b-col>
                                    <b-col md="6" class="text-right">
                                      <span class="textPayment">
                                        {{
                                          formatMoney(
                                            interestZeroPrePaid +
                                              interestZeroExchange,
                                          )
                                        }}
                                      </span>
                                    </b-col>
                                  </b-row>
                                </div>
                                <b-row v-else class="mb-1">
                                  <b-col md="6">
                                    <span class="textTitlePayment">
                                      Khách cần trả:
                                    </span>
                                  </b-col>
                                  <b-col md="6" class="text-right">
                                    <span class="textPayment">
                                      {{ formatMoney(finalAmount) }}
                                    </span>
                                  </b-col>
                                </b-row>
                                <BillPayment
                                  ref="bill-payment"
                                  v-if="renderComponent"
                                  :finalAmount="finalAmount"
                                  :billData="mainModel"
                                  :onSubmiting="onPaymentSubmiting"
                                  :disabled="!mainModel.editable"
                                  :isAllowQRCode="isAllowQRCode"
                                  v-on:onUpdate="onUpdatePayment"
                                  v-on:receive-payment="onUpdatePayment"
                                  v-on:receive-payment-mul="onUpdatePaymentV2"
                                  v-on:click-generate-qrcode="onClickGenerateQR"
                                />
                              </b-col>
                            </b-row>
                            <b-row
                              v-if="mainModel.id"
                              class="col-md-12 mb-1 m-0 p-0"
                            >
                              <b-container
                                class="p-0"
                                v-if="checkPermission('TRANSACTION_VIEW')"
                              >
                                <hr
                                  class="hr-text"
                                  data-content="Bút Toán"
                                  style="font-weight: 600"
                                />
                                <b-row>
                                  <b-col md="12" lg="12" sm="12">
                                    <BillTransactions
                                      :billNumber="$route.query.id"
                                    />
                                  </b-col>
                                </b-row>
                              </b-container>
                            </b-row>
                            <b-row class="col-md-12 mb-1 m-0 p-0">
                              <b-col>
                                <b-button
                                  style="
                                    font-weight: 600;
                                    width: 70px;
                                    margin-right: 10px;
                                  "
                                  variant="primary"
                                  size="sm"
                                  @click="onSubmit('save')"
                                  v-if="mainModel.editable"
                                  >Lưu
                                </b-button>
                                <b-button
                                  v-if="canRequestVat"
                                  style="font-weight: 600; margin-right: 10px"
                                  variant="primary"
                                  size="sm"
                                  :disabled="vatActionLoading"
                                  @click="onRequestVat"
                                  >Đề nghị xuất hóa đơn VAT
                                </b-button>
                                <b-button
                                  v-if="canApproveVat"
                                  style="font-weight: 600; margin-right: 10px"
                                  variant="success"
                                  size="sm"
                                  :disabled="vatActionLoading"
                                  @click="onApproveVat"
                                  >Duyệt xuất hóa đơn
                                </b-button>
                                <b-button
                                  v-if="canApproveVat"
                                  style="font-weight: 600; margin-right: 10px"
                                  variant="danger"
                                  size="sm"
                                  :disabled="vatActionLoading"
                                  @click="vatRejectDialog = true"
                                  >Từ chối
                                </b-button>
                                <router-link to="/bills" tag="button">
                                  <b-button
                                    tabindex="16"
                                    style="font-weight: 600; width: 70px"
                                    variant="secondary"
                                    size="sm"
                                    >Hủy
                                  </b-button>
                                </router-link>
                              </b-col>
                            </b-row>
                          </b-form>
                        </div>

                        <div
                          class="py-4 mb-5 full-width"
                          data-wizard-type="step-content"
                        >
                          <b-container class="bv-example-row">
                            <b-table
                              :fields="historyFields"
                              :items="histories"
                              class="table-bordered table-hover col-md-6"
                            >
                              <template v-slot:cell(updatedBy)="row">
                                <p>{{ row.item.updatedBy }}</p>
                                <p>{{ row.item.updatedAt }}</p>
                              </template>
                              <template v-slot:cell(action)="row">
                                <span>
                                  {{
                                    row.index === histories.length - 1
                                      ? 'Tạo mới hóa đơn'
                                      : 'Sửa hóa đơn'
                                  }}
                                </span>
                              </template>
                              <template v-slot:cell(detail)="row">
                                <div
                                  class="orderCode"
                                  @click="viewHistoryDetail(row.item)"
                                  style="cursor: pointer; color: #3699ff"
                                >
                                  <span v-text="`Chi tiết`"></span>
                                </div>
                              </template>
                            </b-table>
                          </b-container>
                        </div>

                        <div
                          class="py-4 mb-5 full-width"
                          data-wizard-type="step-content"
                        >
                          <div class="upload-file col-12">
                            <vue-easy-lightbox
                              escDisabled
                              :visible="previewFile.visible"
                              :imgs="previewFile.imgs"
                              :index="previewFile.index"
                              @hide="handleHidePreviewFile"
                            ></vue-easy-lightbox>

                            <vue-easy-lightbox
                              escDisabled
                              :visible="previewAttachment.visible"
                              :imgs="previewAttachment.imgs"
                              :index="previewAttachment.index"
                              @hide="handleHidePreviewAttachment"
                            ></vue-easy-lightbox>

                            <div>
                              <b-col
                                class="preview-img-container mb-4"
                                v-if="isLoadAttachmentSuccess"
                              >
                                <div>
                                  <!--File Previews-->
                                  <div class="d-flex flex-wrap">
                                    <div
                                      v-for="(item, index) in attachments"
                                      :key="index"
                                      class="img-container align-items-start"
                                    >
                                      <img
                                        v-if="typecheck(item.fileName)"
                                        :src="item.url"
                                        class="preview-img"
                                        width="80"
                                        height="100"
                                        :alt="item.originalName"
                                        @click="
                                          showMultiplePreViewAttachment(index)
                                        "
                                      />
                                      <img
                                        v-else
                                        src="../../../assets/google-docs.svg"
                                        class="preview-img"
                                        width="80"
                                        height="100"
                                        :alt="item.originalName"
                                        @click="
                                          showMultiplePreViewAttachment(index)
                                        "
                                      />
                                      <i
                                        class="fas fa-times-circle text-danger close"
                                        @click="deleteAttachment(item.id)"
                                      >
                                      </i>
                                      <a
                                        :download="item.fileName"
                                        :href="item.url"
                                        ><i
                                          class="fas fa-arrow-circle-down text-warning remove"
                                        >
                                        </i
                                      ></a>
                                      <small class="text-black">
                                        {{ item.originalName }}
                                      </small>
                                    </div>
                                  </div>
                                </div>
                              </b-col>

                              <!--UPLOAD-->
                              <form
                                enctype="multipart/form-data"
                                novalidate
                                class="mb-4"
                              >
                                <b-button
                                  size="sm"
                                  variant="secondary"
                                  @click="openFileUpload()"
                                  class="font-weight-bolder mr-2"
                                >
                                  <i class="fas fa-paperclip"></i>
                                  Đính kèm tệp
                                </b-button>
                                <b-button
                                  size="sm"
                                  variant="warning"
                                  @click="submitFileUpload()"
                                  class="font-weight-bolder"
                                  v-if="uploadedFiles.length"
                                >
                                  <i class="fas fa-upload"></i>
                                  Tải tệp lên
                                </b-button>
                                <b-form-file
                                  v-model="fileAttach.files"
                                  ref="upload-files"
                                  id="upload-files"
                                  class="mb-2 d-none input-file"
                                  multiple
                                  :name="uploadFieldName"
                                  :disabled="isSaving"
                                  v-on:change="
                                    filesChange(
                                      $event.target.name,
                                      $event.target.files,
                                    );
                                    fileCount = $event.target.files.length;
                                  "
                                />

                                <p v-if="isSaving">
                                  Đang tải {{ fileCount }} tệp...
                                </p>
                                <div v-if="isFailed" class="d-flex">
                                  <small class="text-danger"
                                    >Tải tệp thất bại.</small
                                  >
                                  <small>
                                    <a
                                      href="javascript:void(0)"
                                      @click="reset()"
                                      >Thử lại</a
                                    >
                                  </small>
                                  <pre>{{ uploadError }}</pre>
                                </div>
                              </form>

                              <b-col
                                class="preview-img-container mb-4"
                                v-if="isSuccess"
                              >
                                <div>
                                  <!--File Previews-->
                                  <div class="d-flex">
                                    <div
                                      v-for="(item, index) in uploadedFiles"
                                      :key="index"
                                      class="img-container align-items-start"
                                    >
                                      <img
                                        v-if="typecheck(item.fileName)"
                                        :src="item.url"
                                        class="preview-img"
                                        width="80"
                                        height="100"
                                        :alt="item.originalName"
                                        @click="showMultiplePreViewFile(index)"
                                      />
                                      <img
                                        v-else
                                        src="../../../assets/google-docs.svg"
                                        class="preview-img"
                                        width="80"
                                        height="100"
                                        :alt="item.originalName"
                                        @click="showMultiplePreViewFile(index)"
                                      />

                                      <i
                                        class="fas fa-times-circle text-danger close"
                                        @click="
                                          removeFile(
                                            fileCount,
                                            uploadedFiles.indexOf(item),
                                          )
                                        "
                                      >
                                      </i>
                                    </div>
                                  </div>
                                </div>
                              </b-col>
                              <!--SUCCESS-->
                              <p v-if="isSuccess">
                                <b>Tổng số {{ uploadedFiles.length }} tệp</b>
                              </p>
                              <!--FAILED-->
                            </div>
                          </div>
                        </div>
                        <!-- Phiếu thu cũ -->
                        <!-- <div
							class="py-4 mb-5 full-width"
							data-wizard-type="step-content"
						  >
							<TradeIn
							  :tradeIn="tradeIn"
							  :customerId="mainModel.customerModel.customerId"
							/>
						  </div> -->
                      </div>
                    </div>
                  </div>
                </b-skeleton-wrapper>
              </div>
            </div>
          </div>
          <!--end: Wizard Nav -->
        </b-card>
        <BillGiftModal
          ref="bill-gift-modal"
          :billItemId="selectedBillItem.billItemId || ''"
          :storeId="mainModel.storeId || ''"
          :productName="selectedBillItem.productName || ''"
          :productId="selectedBillItem.productId || null"
          :attachedGiftProductIds="
            selectedBillItem.attachedGiftProductIds || []
          "
          v-on:addGift="addGift"
        />
        <BillAttachModal
          ref="bill-attach-modal"
          :billItemId="selectedBillItem.billItemId"
          :productName="selectedBillItem.productName"
          :storeId="mainModel.storeId"
          :attachItems="selectedBillItem.attachItems"
          v-on:addAttach="addAttach"
        />
        <BillWarrantyModal
          ref="bill-warranty-modal"
          :productName="selectedBillItem.productName"
          :storeId="mainModel.storeId"
          :productId="selectedBillItem.productId"
          v-on:addWarranty="addWarranty"
        />
        <ChangeGiftModal
          ref="change-gift-modal"
          :productId="selectedBillItem.productId"
          :listProductVariant="selectedBillItem.listProductVariant"
          v-on:changeGift="onChangeGift"
        />
        <BillNoteModal
          ref="bill-note-modal"
          :productName="selectedBillItem.productName"
          :note="selectedBillItem.note"
          v-on:addNote="onChangeNote"
        />
        <ImeiListByProduct
          ref="list-imei-modal"
          :billItemId="selectedBillItem.billItemId"
          :productName="selectedBillItem.productName"
          :storeId="mainModel.storeId"
          :productId="selectedBillItem.productId"
          v-on:applyImei="applyImei"
        />
        <ListChassisEngine
          ref="list-chassis-engine-modal"
          :billItemId="selectedBillItem.billItemId"
          :productName="selectedBillItem.productName"
          :storeId="mainModel.storeId"
          :productId="selectedBillItem.productId"
          v-on:applyChassisEngine="applyChassisEngine"
        />
        <ListSerial
          ref="list-serial-modal"
          :billItemId="selectedBillItem.billItemId"
          :productName="selectedBillItem.productName"
          :storeId="mainModel.storeId"
          :productId="selectedBillItem.productId"
          v-on:applySerialNumber="applySerialNumber"
        />
        <!-- <UpsertShiftWorkConfigModal
			v-on:fetchShiftWorkConfig="fetchShiftWorkConfig"
			ref="modal-upsert-shiftWork"
			:shiftWorkConfig="shiftWorkConfigSelected"
		  /> -->

        <ActiveImei ref="active-imei-modal" />
        <QRCodeModal
          ref="qr-code-modal"
          :qrCode="qrCode"
          :billNumber="mainModel.billNumber"
          :type="REFERENCE_TYPE.BILL"
          :transferAmount="transferAmount"
          :payment="qrCodePaymentInfo"
          :storeId="mainModel.storeId"
          @onGenerateQR="onGenerateQR"
          @afterGenerateQR="afterGenerateQR"
        />
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <FlexibleComboModal
          ref="flexible-combo"
          :flexibleComboItem="flexibleComboItem"
          :storeId="mainModel.storeId"
          v-on:addComboChild="addComboChild"
        />
        <VoucherApplyModal
          ref="apply-voucher-modal"
          :billItemId="selectedBillItem.billItemId"
          :productName="selectedBillItem.productName"
          :storeId="mainModel.storeId"
          :productId="selectedBillItem.productId"
          :productAmount="selectedBillItem.productAmount"
          :customerId="mainModel.customerModel.customerId"
          customerType="CUSTOMER"
          :contractId="mainModel.contractId"
          v-on:applyVoucherItem="onApplyVoucherItem"
        />
        <b-modal
          v-model="vatRejectDialog"
          title="Từ chối đề nghị xuất hóa đơn VAT"
          ok-title="Xác nhận từ chối"
          cancel-title="Đóng"
          :ok-disabled="!vatRejectReasonInput.trim() || vatActionLoading"
          @ok="onRejectVat"
        >
          <b-form-group label="Lý do từ chối *">
            <b-form-textarea
              v-model="vatRejectReasonInput"
              rows="3"
              placeholder="Nhập lý do từ chối..."
            />
          </b-form-group>
        </b-modal>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import {
  AMOUNT_TYPE,
  BILL_ITEM_TYPE,
  DISCOUNT_AMOUNT_TYPE,
  PAYMENT_STATUS,
  PAYMENT_TYPE,
  PRODUCT_SEARCH_TYPE,
  PRODUCT_TYPE,
  REFERENCE_TYPE,
  UPLOAD_ENTITY,
  PRODUCT_TYPE_ENUM,
  BILL_VAT_STATUS,
  BILL_VAT_STATUS_LABEL,
} from '@/utils/enum';
import KTCodePreview from '@/view/content/CodeTab.vue';
import KTWizard from '@/assets/js/components/wizard';
import KTUtil from '@/assets/js/components/util';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import JwtService from '@/core/services/jwt.service';
import moment from 'moment';
import axios from 'axios';
import Swal from 'sweetalert2';
import {
  convertPrice,
  currencyMask,
  makeToastFaile,
  makeToastFailHtml,
  makeToastSuccess,
  unMaskPrice,
  formatDate,
} from '@/utils/common';
import decounce from 'debounce';
import { v4 } from 'uuid';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { TIME_TRIGGER } from '@/utils/constants';
import SearchStore from '@/view/components/stores/SearchStore.vue';
import CustomerInfo from '@/view/components/customers/CustomerInfo.vue';
import EmployeeInfo from '@/view/components/bills/EmployeeInfo.vue';
// import WarrantyCustomerInfo from '@/view/components/bills/WarrantyCustomerInfo.vue';
import BillPayment from '@/view/components/bills/BillPayment.vue';
import BillNote from '@/view/components/bills/BillNote.vue';
import BillGiftModal from '@/view/components/bills/BillGiftModal';
import BillAttachModal from '@/view/components/bills/BillAttachModal';
import BillWarrantyModal from '@/view/components/bills/BillWarrantyModal';
import ChangeGiftModal from '@/view/components/bills/ChangeGiftModal';
import BillNoteModal from '@/view/components/bills/BillNoteModal';
import ImeiListByProduct from '@/view/components/bills/ImeiListByProduct';
import ListChassisEngine from '@/view/components/bills/ListChassisEngine';
import ListSerial from '@/view/components/bills/ListSerial';

// import UpsertShiftWorkConfigModal from '@/view/components/shiftWorkConfig/UpsertShiftWorkConfigModal';
import BillItem from '@/view/components/BillItem.vue';

import BillTransactions from '@/view/components/BillTransactions.vue';
import ActiveImei from '@/view/components/imeis/ActiveImei';
// import WarrantyTransaction from '@/view/components/WarrantyTransaction.vue';
import localData from '@/utils/saveDataToLocal';
import VueEasyLightbox from 'vue-easy-lightbox';
import { cmdUrl } from '@/utils/apiUrl';
import { cloneDeep, findLastIndex, map, pullAt, sumBy, uniq } from 'lodash';
import { mapGetters } from 'vuex';
import {
  PURGE_INSTALLMENT_PROGRAM,
  PURGE_INTEREST_ZERO,
  SET_INSTALLMENT_PROGRAM,
  SET_INTEREST,
} from '@/core/services/store/modules/payment/payment-installment.module';
import { EventBus } from '@/core/services/event-bus';
import QRCodeModal from '@/view/components/bills/QRCodeModal.vue';
import db from '@/firebase/init';
import { deleteDoc, doc, onSnapshot } from 'firebase/firestore';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import FlexibleComboModal from '@/view/components/bills/FlexibleComboModal';
// import TradeIn from '@/view/components/bills/TradeIn.vue';
import VoucherApplyModal from '@/view/components/voucher/VoucherApplyModal.vue';
import { ProductSearchOption } from './models/ProductSearchOption';
import { BillItemLogicModal } from '@/view/pages/bills/models/BillItemLogicModal';
import { FlexibleComboSearchOption } from '@/view/pages/bills/models/FlexibleComboSearchOption';
import { BILL_TYPE } from '../../../utils/enum';

const BillVatInfo = () =>
  import(/* webpackPrefetch: true */ '@/view/components/bills/BillVatInfo.vue');

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  mixins: [validationMixin],
  data() {
    return {
      PRODUCT_SEARCH_TYPE,
      PRODUCT_TYPE_ENUM,
      BILL_ITEM_TYPE,
      productAttach: {},
      selectingProductId: null,
      isAllowQRCode: false,
      shiftWorkConfigSelected: null,
      shiftWorkConfig: null,
      qrCodePaymentInfo: {},
      REFERENCE_TYPE,
      isLoading: false,
      fullPage: true,
      qrCode: {
        image: '',
        code: '',
      },
      productLoading: false,
      listTypeSearch: [
        {
          id: PRODUCT_SEARCH_TYPE.PRODUCT_NAME,
          name: 'Tìm sản phẩm',
        },
        // {
        //   id: PRODUCT_SEARCH_TYPE.FLEXIBLE_COMBO,
        //   name: 'Tìm bộ combo',
        // },
        {
          id: PRODUCT_SEARCH_TYPE.CHASSIS_ENGINE,
          name: 'Tìm sản phẩm theo số khung',
        },
        {
          id: PRODUCT_SEARCH_TYPE.SERIAL,
          name: 'Tìm sản phẩm serial',
        },
      ],
      selectTypeSearch: PRODUCT_SEARCH_TYPE.PRODUCT_NAME,
      filteredOptionsProduct: [{ data: [] }],
      optionsProduct: [
        {
          data: [],
        },
      ],
      searchProduct: '',
      isSearching: false,
      filteredOptionsStore: [],
      optionsStore: [
        {
          data: [],
        },
      ],
      searchStore: '',
      inputSearchProductProp: {
        class: 'autosuggest__input',
        placeholder: 'Tìm kiếm theo tên, mã, mã vạch sản phẩm',
        disabled: true,
      },
      mainModel: {
        id: null,
        billNumber: null,
        contractId: null,
        contractNumber: null,
        storeId: null,
        stockSlipId: null,
        totalAmount: 0,
        storeName: '',
        siteCode: '',
        discountType: 'AMOUNT',
        discountAmount: 0,
        couponCode: '',
        isCountPoint: true,
        subtractPoint: 0,
        otpCode: '',
        isSubtractPointValidated: false,
        moneyTransfered: 0,
        moneyPaid: 0,
        moneyCredit: 0,
        moneyInstallment: 0,
        // Tổng tiền KH đã thanh toán (net = Σ CASH+TRANSFER+CREDIT − Σ REFUND) trên
        // HĐ mua bán khi convert HĐ → hóa đơn bán lẻ. Chỉ dùng để hiển thị + đối trừ
        // vào "Khách cần trả" (computed finalAmount/totalPaid). KHÔNG đẩy vào mảng
        // payment input (mainModel.transfer/cash/credits/installments) — backend bill
        // detail đã tự merge payments của HĐ qua bill.contractId → tránh double-count.
        moneyPrepaidContract: 0,
        totalAmountPoint: 0,
        customerShipFee: 0,
        codeShip: '',
        customerModel: {
          customerId: null,
          customerMobile: '',
          customerName: '',
          customerLastName: '',
          customerAddress: '',
          customerCity: null,
          customerDistrict: null,
          customerWard: null,
          totalPoint: 0,
          customerAppellation: null,
          // Pháp lý KH (đồng bộ field thêm ở HĐMB) — date dạng YYYY-MM-DD.
          customerCccdNo: '',
          customerCccdDate: '',
          customerCccdPlace: '',
          customerEmail: '',
          customerDob: '',
          customerKind: 'CUSTOMER',
          customerMst: '',
          customerRepresentative: '',
          customerBusinessId: null,
        },
        warrantyCustomerModel: {
          customerId: null,
          customerMobile: '',
          customerName: '',
          customerLastName: '',
        },
        billEmployeeInfo: {
          saleId: null,
          saleName: '',
          technicalId: null,
          technicalName: '',
          cashierId: null,
          cashierName: '',
          accessoryStaffId: null,
          accessoryStaffName: '',
          managerId: null,
          managerName: '',
          assistantId: null,
          assistantName: '',
          customerReceptionId: null,
          customerReceptionName: '',
          shipperId: null,
          shipperName: '',
        },
        companyBill: false,
        vatInvoice: {
          vatCompanyType: 1,
          taxCode: '',
          companyAddress: '',
          companyName: '',
          email: '',
        },
        paymentInfo: {
          //tiền mặt
          cashAmount: 0,
          cashAccountantName: '',
          cashAccountId: null,
          //chuyển khoản
          transferAmount: 0,
          transferAccountantName: '',
          transferAccountantId: null,
          transferReferenceCode: '',
          //quẹt thẻ
          creditAmount: 0,
          creditAccountantName: '',
          creditAccountantId: null,
          creditCode: '',
          creditCardNo: '',
          //phí quẹt thẻ
          creditCardFee: 0,
          creditFeeAccountantName: '',
          creditFeeAccountantId: null,
          payCreditFeeType: 1,
          //trả góp
          installedMoneyAmount: 0,
          installmentCode: '',
          installmentAccountName: '',
          installMoneyAccountId: null,
          customerIndentifyNo: '',
          installmentProgramMonthNo: 0,
          installmentProgramPrepayPercent: 0,
        },
        billNote: {
          customerNote: '',
          saleNote: '',
          warrantyNote: '',
        },
        orderSourceId: null,
        editable: true,
        fromBillNumber: null,
        storeDisable: false,
        installments: [],
        credits: [],
        transfer: [],
        cash: [],
        refunds: [],
        // Trạng thái xuất hóa đơn VAT (chỉ HĐBL RETAIL từ HĐ)
        vatStatus: null,
        vatRejectReason: null,
        vatRequestedAt: null,
        vatApprovedAt: null,
      },
      // State modal từ chối đề nghị xuất hóa đơn VAT
      vatRejectDialog: false,
      vatRejectReasonInput: '',
      vatActionLoading: false,
      mockupCustomerForBill: {},
      listBillItem: [],
      listAmountType: [
        {
          id: 'AMOUNT',
          name: '$',
        },
        {
          id: 'PERCENT',
          name: '%',
        },
      ],
      mask: currencyMask,
      stateCouponCode: null,
      stateOTP: null,
      isValidCoupon: false,
      validCouponCode: '',
      selectedBillItem: {
        billItemId: null,
        productName: '',
        productId: null,
        attachedGiftProductIds: [],
        productAmount: 0,
        attachItems: [],
        listProductVariant: [],
        note: '',
      },
      isValidImei: true,
      onSubmiting: false,
      pointSetting: {
        rate: 0,
        allowRoundToDown: false,
      },
      listCustomerSource: [],
      couponValue: 0,
      fileAttach: {
        files: [],
        fileModels: [],
      },
      uploadedFiles: [],
      fileCount: 0,
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'photos',
      hashName: null,
      previewFile: {
        visible: false,
        imgs: '',
        index: 0,
      },
      previewAttachment: {
        visible: false,
        imgs: '',
        index: 0,
      },
      attachments: null,
      isLoadAttachmentSuccess: false,
      histories: [],
      historyFields: [
        {
          key: 'updatedBy',
          label: 'Người tạo',
          thStyle: { textAlign: 'center' },
        },
        {
          key: 'action',
          label: 'Hành động',
          sortable: false,
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
        },
        {
          key: 'detail',
          label: '',
          sortable: false,
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
        },
      ],
      prevSubtractPoint: 0,
      prevCouponCode: '',
      renderComponent: false,
      pageTitle: null,
      onPaymentSubmiting: false,
      orderNotComplete: null,
      isValidTaxCode: true,
      isValidEmail: true,
      transferAmount: 0,
      flexibleComboItem: {
        id: null,
        name: '',
        code: '',
        discountAmount: 0,
        discountType: AMOUNT_TYPE.MONEY,
        listItem: [],
      },
      tradeIn: {},
      billType: null,
    };
  },
  validations: {
    searchStore: {
      required,
    },
  },
  components: {
    Loading,
    KTCodePreview,
    SearchStore,
    BillItem,
    CustomerInfo,
    EmployeeInfo,
    // WarrantyCustomerInfo,
    BillVatInfo,
    BillPayment,
    BillNote,
    BillGiftModal,
    BillAttachModal,
    BillWarrantyModal,
    ChangeGiftModal,
    BillNoteModal,
    ImeiListByProduct,
    BillTransactions,
    // WarrantyTransaction,
    VueEasyLightbox,
    ActiveImei,
    QRCodeModal,
    // UpsertShiftWorkConfigModal,
    FlexibleComboModal,
    // TradeIn,
    VoucherApplyModal,
    ListChassisEngine,
    ListSerial,
  },
  destroyed() {
    this.$store.dispatch(PURGE_INTEREST_ZERO);
    this.$store.dispatch(PURGE_INSTALLMENT_PROGRAM);
    EventBus.$off('onSelectTradeIn', this.onSelectTradeIn);
  },
  watch: {
    // getInstallmentInterestZero: {
    //   handler(value) {
    //     this.fetchProgramByProductIds(value);
    //   },
    //   deep: true,
    // },
  },
  computed: {
    ...mapGetters(['getInstallmentInterestZero', 'getInstallmentProgram']),
    vatStatusLabel() {
      return this.mainModel.vatStatus
        ? BILL_VAT_STATUS_LABEL[this.mainModel.vatStatus]
        : '';
    },
    vatPillClass() {
      const map = {
        [BILL_VAT_STATUS.NOT_ISSUED]: 'bvat-pill--pending',
        [BILL_VAT_STATUS.REQUESTED]: 'bvat-pill--requested',
        [BILL_VAT_STATUS.ISSUED]: 'bvat-pill--issued',
      };
      return map[this.mainModel.vatStatus] || '';
    },
    canRequestVat() {
      return (
        this.mainModel.vatStatus === BILL_VAT_STATUS.NOT_ISSUED &&
        this.checkPermission('VAT_INVOICE_REQUEST')
      );
    },
    canApproveVat() {
      return (
        this.mainModel.vatStatus === BILL_VAT_STATUS.REQUESTED &&
        this.checkPermission('VAT_INVOICE_INSERT')
      );
    },
    totalAmountBeforeDiscount() {
      let total = 0;
      for (let index = 0; index < this.listBillItem.length; index++) {
        const element = this.listBillItem[index];
        const effectivePrice = this.getBillItemPriceByType(element);

        const totalPrice =
          unMaskPrice(effectivePrice) * unMaskPrice(element.quantity);
        // Check discount type
        total += totalPrice;
      }
      // for (let index = 0; index < this.listBillItem.length; index++) {
      //   const element = this.listBillItem[index];
      //   if (element.billItemType === BILL_ITEM_TYPE.PRODUCT) {
      //     const totalPrice =
      //       unMaskPrice(element.price) * unMaskPrice(element.quantity);
      //     // Check discount type
      //     total += totalPrice;
      //   } else if (
      //     element.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS &&
      //     element.checked === false
      //   ) {
      //     total -=
      //       unMaskPrice(element.returnPrice) * unMaskPrice(element.quantity);
      //   } else if (
      //     element.billItemType === BILL_ITEM_TYPE.PRODUCT_PROMTION &&
      //     element.checked === true
      //   ) {
      //     total +=
      //       unMaskPrice(element.returnPrice) * unMaskPrice(element.quantity);
      //   }
      // }
      return total;
    },

    mainBillItems() {
      return this.listBillItem.filter((item) => !item.belongBillDetailId);
    },

    attachBillItems() {
      return this.listBillItem.filter((item) => item.belongBillDetailId);
    },

    interestZeroExchange() {
      const [firstInstallment] = this.mainModel.installments;
      if (firstInstallment) {
        return firstInstallment.child
          ? firstInstallment.child.paymentAmount
          : 0;
      }
      return 0;
    },
    interestZeroLoan() {
      if (!this.interestZeroPrePaid) return 0;
      return this.finalAmount - this.interestZeroPrePaid;
    },
    interestZeroPrePaid() {
      return (
        (this.finalAmount *
          this.getInstallmentProgram.installmentProgramPrepayPercent || 0) / 100
      );
    },
    totalAmount() {
      let total = 0;
      for (let index = 0; index < this.listBillItem.length; index++) {
        const billItem = this.listBillItem[index];
        const effectivePrice = this.getBillItemPriceByType(billItem);

        const totalPrice =
          unMaskPrice(effectivePrice) * unMaskPrice(billItem.quantity);

        if (billItem.discountType === DISCOUNT_AMOUNT_TYPE.PERCENT) {
          const discountAmount = totalPrice * billItem.discount;
          total += totalPrice - (discountAmount / 100).toFixed(0);
        } else {
          total += totalPrice - unMaskPrice(billItem.discount);
        }
      }
      // return total;
      // if (!this.mainModel.billNumber) {
      // let total = 0;
      // for (let index = 0; index < this.listBillItem.length; index++) {
      //   const element = this.listBillItem[index];
      //   if (element.quantity != 0) {
      //     if (element.billItemType === BILL_ITEM_TYPE.PRODUCT) {
      //       const totalPrice =
      //         unMaskPrice(element.price) * unMaskPrice(element.quantity);
      //       // Check discount type
      //       if (element.discountType == AMOUNT_TYPE.PERCENT) {
      //         const discountAmount = totalPrice * element.discount;
      //         total += totalPrice - (discountAmount / 100).toFixed(0);
      //       } else {
      //         total += totalPrice - unMaskPrice(element.discount);
      //       }
      //     } else if (
      //       element.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS &&
      //       element.checked === false
      //     ) {
      //       total -=
      //         unMaskPrice(element.returnPrice) *
      //         unMaskPrice(element.quantity);
      //     } else if (
      //       element.billItemType === BILL_ITEM_TYPE.PRODUCT_PROMTION &&
      //       element.checked === true
      //     ) {
      //       total +=
      //         unMaskPrice(element.returnPrice) *
      //         unMaskPrice(element.quantity);
      //     }
      //   }
      // }
      const discountAmount = this.mainModel.discountAmount
        ? unMaskPrice(this.mainModel.discountAmount)
        : 0;
      if (this.mainModel.discountType == DISCOUNT_AMOUNT_TYPE.MONEY) {
        total = total - discountAmount;
      } else {
        total = total - (total * discountAmount) / 100;
      }
      return total || 0;
      // }

      // return this.mainModel.totalAmount || 0;
    },
    totalAmountReturn() {
      let total = 0;
      for (let index = 0; index < this.listBillItem.length; index++) {
        const element = this.listBillItem[index];
        if (
          element.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS &&
          element.checked === false
        ) {
          total +=
            unMaskPrice(element.returnPrice) * unMaskPrice(element.quantity);
        }
      }
      return total;
    },
    addPoint() {
      if (!this.pointSetting.rate) {
        return 0;
      }

      if (this.pointSetting.allowRoundToDown) {
        return this.totalAmount
          ? parseInt(this.totalAmount / this.pointSetting.rate)
          : 0;
      }

      return this.totalAmount
        ? Math.ceil(this.totalAmount / this.pointSetting.rate)
        : 0;
    },
    finalAmount() {
      if (!this.totalAmount) {
        return 0;
      }

      const final =
        this.totalAmount -
        this.mainModel.moneyTransfered -
        this.mainModel.moneyPaid -
        this.mainModel.moneyCredit -
        this.mainModel.moneyInstallment -
        // Đối trừ tiền KH đã thanh toán trên HĐ mua bán (khi convert HĐ → hóa đơn).
        Number(this.mainModel.moneyPrepaidContract || 0) -
        // this.mainModel.totalAmountPoint +
        this.mainModel.customerShipFee;
      // const final = this.totalAmount;
      return final;
    },
    totalPaid() {
      return (
        this.mainModel.moneyPaid +
        this.mainModel.moneyTransfered +
        this.mainModel.moneyCredit +
        this.mainModel.moneyInstallment +
        Number(this.mainModel.moneyPrepaidContract || 0)
      );
    },
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    selectedProductIds() {
      if (
        !this.listBillItem ||
        this.listBillItem.length < 1 ||
        !this.selectingProductId
      ) {
        return [];
      }
      const productIds = map(this.listBillItem, 'productId');
      const index = findLastIndex(productIds, (item) => {
        return item === this.selectingProductId;
      });
      pullAt(productIds, productIds[index]);
      return uniq(productIds);
    },
  },
  async mounted() {
    this.reset();
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Hóa đơn bán lẻ', route: '/bills' },
      { title: 'Danh sách hóa đơn bán lẻ', route: '/bills' },
      { title: 'Thêm mới hóa đơn bán lẻ' },
    ]);
    // this.getPointRate();
    // this.getListOrderSource();
    this.mainModel.orderId = this.$route.query.fromOrderId
      ? this.$route.query.fromOrderId
      : null;
    this.mainModel.contractId = this.$route.query.fromContractId
      ? this.$route.query.fromContractId
      : null;
    this.mainModel.billNumber = this.$route.query.id
      ? this.$route.query.id
      : null;
    if (this.mainModel.billNumber) {
      if (this.$route.name === 'add-bill') {
        this.mainModel.fromBillNumber = this.$route.query.id;
      } else {
        this.isAllowQRCode = true;
      }
      this.getBillById();
      this.fetchBillHistory();

      this.loadAttachments();
    } else {
      if (this.mainModel.orderId) {
        this.getOrderById();
      } else if (this.mainModel.contractId) {
        this.getContractById();
      } else {
        this.renderComponent = true;
      }
    }
    if (this.$route.query.type === 'convert') {
      this.billType = 'convert';
    }

    // Initialize form wizard
    const hashName = this.$route.hash ? this.$route.hash.split('#')[1] : '';

    this.hashName = hashName === 'attach' ? 'attach' : null;

    const wizard = new KTWizard('kt_wizard_v4_bill', {
      startStep: hashName === 'attach' ? 3 : 1, // initial active step number
      clickableSteps: true, // allow step clicking
    });

    wizard.on('beforeNext', function (/*wizardObj*/) {});

    wizard.on('change', function (/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, TIME_TRIGGER);
    });

    this.fetchStoreByUser();
    this.getPaymentResult();
    EventBus.$on('onSelectTradeIn', this.onSelectTradeIn);
  },
  methods: {
    formatDate,
    async onRequestVat() {
      try {
        this.vatActionLoading = true;
        await ApiService.post(`bills/${this.mainModel.id}/vat-request`);
        makeToastSuccess('Đã gửi đề nghị xuất hóa đơn VAT');
        await this.getBillById();
      } catch (e) {
        makeToastFaile(
          e?.response?.data?.message || 'Đề nghị xuất hóa đơn VAT thất bại',
        );
      } finally {
        this.vatActionLoading = false;
      }
    },
    async onApproveVat() {
      try {
        this.vatActionLoading = true;
        await ApiService.post(`bills/${this.mainModel.id}/vat-approve`);
        makeToastSuccess('Đã duyệt xuất hóa đơn VAT');
        await this.getBillById();
      } catch (e) {
        makeToastFaile(
          e?.response?.data?.message || 'Duyệt xuất hóa đơn thất bại',
        );
      } finally {
        this.vatActionLoading = false;
      }
    },
    async onRejectVat(bvModalEvt) {
      if (bvModalEvt) bvModalEvt.preventDefault();
      const reason = this.vatRejectReasonInput.trim();
      if (!reason) return;
      try {
        this.vatActionLoading = true;
        await ApiService.post(`bills/${this.mainModel.id}/vat-reject`, {
          reason,
        });
        this.vatRejectDialog = false;
        this.vatRejectReasonInput = '';
        makeToastSuccess('Đã từ chối đề nghị xuất hóa đơn VAT');
        await this.getBillById();
      } catch (e) {
        makeToastFaile(e?.response?.data?.message || 'Từ chối thất bại');
      } finally {
        this.vatActionLoading = false;
      }
    },
    isEnginePlaceholder(engine) {
      if (typeof engine !== 'string') return false;
      const v = engine.trim();
      return v.length > 0 && /^x+$/i.test(v);
    },
    onSelectTradeIn(tradeIn) {
      this.tradeIn = { ...tradeIn };
      this.mainModel.stockSlipId = tradeIn.stockSlip.id;
    },
    onClickGenerateQR(payment) {
      if (payment.status === PAYMENT_STATUS.SUCCESS) {
        return makeToastFaile('Vui lòng tạo thanh toán mới!');
      }
      this.qrCodePaymentInfo = payment;
      setTimeout(() => {
        this.$refs['qr-code-modal'].generateQRCode();
      }, TIME_TRIGGER);
    },
    onGenerateQR() {
      this.isLoading = true;
    },
    afterGenerateQR() {
      this.isLoading = false;
    },

    getRelatedItems(mainItemId) {
      const relatedData = this.attachBillItems.filter(
        (item) => item.belongBillDetailId === mainItemId,
      );
      return relatedData;
    },

    getBillItemPriceByType(billItem) {
      let currentType = billItem.billItemType || BILL_ITEM_TYPE.PRODUCT;

      switch (currentType) {
        case BILL_ITEM_TYPE.PRODUCT_BONUS:
          return 0;
        default:
          return billItem.price;
      }
    },

    async getPaymentResult() {
      const VERIFY_COLLECTION = 'payment-verify-results';
      onSnapshot(
        doc(db, VERIFY_COLLECTION, String(this.mainModel.billNumber)),
        (snap) => {
          if (snap.exists()) {
            const snapData = snap.data();
            if (
              String(snapData.referenceNumber) ===
              String(this.mainModel.billNumber)
            ) {
              //  remove doc
              deleteDoc(
                doc(db, VERIFY_COLLECTION, String(this.mainModel.billNumber)),
              );
              this.$refs['qr-code-modal'].hideModal();
              Swal.fire(
                'Thành công',
                'Bạn đã thanh toán thành công!',
                'success',
              ).then(() => {
                this.$router.go(this.$router.currentRoute);
              });
            }
          }
        },
      );
    },
    onShiftWorkConfigSelected() {
      for (const jobTitle in this.mainModel.billEmployeeInfo) {
        if (jobTitle != 'saleId' && jobTitle != 'saleName') {
          this.mainModel.billEmployeeInfo[jobTitle] =
            this.shiftWorkConfig[jobTitle];
        }
      }
    },
    resetEmployData() {
      for (const key in this.mainModel.billEmployeeInfo) {
        if (key != 'saleId' && key != 'saleName') {
          if (key.includes('Id')) {
            this.mainModel.billEmployeeInfo[key] = null;
          } else if (key.includes('Name')) {
            this.mainModel.billEmployeeInfo[key] = '';
          }
        }
      }
    },
    linkToOrder: function (item) {
      const { href } = this.$router.resolve({
        name: 'edit-order',
        params: { id: item },
      });
      window.open(href, '_blank');
    },
    linkToContract: function (contractId) {
      if (!contractId) return;
      const { href } = this.$router.resolve({
        name: 'edit-contract',
        params: { id: contractId },
      });
      window.open(href, '_blank');
    },
    validateState(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    formatMoney(value) {
      return convertPrice(value);
    },
    async onSelectedProduct(option) {
      // if (this.selectTypeSearch === PRODUCT_SEARCH_TYPE.FLEXIBLE_COMBO) {
      //   this.flexibleComboItem.name = option.item.productName;
      //   this.flexibleComboItem.id = option.item.productId;
      //   this.flexibleComboItem.code = option.item.productCode;
      //   this.flexibleComboItem.discountAmount = option.item.discountAmount;
      //   this.flexibleComboItem.discountType = option.item.discountType;
      //   this.flexibleComboItem.listItem = option.item.listItem;
      //   this.showModalFlexibleCombo();
      //   return;
      // }

      this.searchProduct = '';
      const selectedProduct = option.item;
      // let imeiCode = '';
      let chassisNumber = '';
      let engineNumber = '';
      let serialNumber = '';
      let productChassisId = null;
      let productSerialId = null;
      let productType = selectedProduct.productType;
      this.selectingProductId = selectedProduct.productId;
      // if (this.selectTypeSearch === PRODUCT_SEARCH_TYPE.IMEI_CODE) {
      //   imeiCode = selectedProduct.imeiCode;
      //   productType = PRODUCT_TYPE.PRODUCT_IMEI;
      // }
      if (this.selectTypeSearch === PRODUCT_SEARCH_TYPE.CHASSIS_ENGINE) {
        chassisNumber = selectedProduct.chassisNumber;
        engineNumber = selectedProduct.engineNumber;
        productChassisId = selectedProduct.productChassis?.id;
      } else if (this.selectTypeSearch === PRODUCT_SEARCH_TYPE.SERIAL) {
        serialNumber = selectedProduct.serialNumber;
        productSerialId = selectedProduct.productSeries?.id;
      }
      const programPrice = this.getInstallmentInterestZero
        ? option.item.listedPrice
        : option.item.sellingPrice;

      const billItem = Object.assign(
        {},
        new BillItemLogicModal({
          data: selectedProduct,
          // importPrice: unMaskPrice(selectedProduct.importPrice) || 0,
          storeId: this.mainModel.storeId,
          programPrice,
          productType,
          // imeiCode,
          chassisNumber,
          engineNumber,
          serialNumber,
          productChassisId,
          productSerialId,
        }),
      );
      if (this.selectTypeSearch === PRODUCT_SEARCH_TYPE.CHASSIS_ENGINE) {
        if (
          this.isExistChassisEngine(
            this.listBillItem,
            chassisNumber,
            engineNumber,
          )
        ) {
          return makeToastFaile(
            'Số khung hoặc số máy đã tồn tại trong hóa đơn',
          );
        }
        this.listBillItem.push(billItem);
        await this.fetchProductAttach(selectedProduct.productId, billItem.id);
      } else if (this.selectTypeSearch === PRODUCT_SEARCH_TYPE.SERIAL) {
        if (this.isExistSerialNumber(this.listBillItem, serialNumber)) {
          return makeToastFaile('Số serial đã tồn tại trong hóa đơn');
        }
        this.listBillItem.push(billItem);
        await this.fetchProductAttach(selectedProduct.productId, billItem.id);
      } else {
        if (
          selectedProduct.productType === PRODUCT_TYPE_ENUM.SERVICE ||
          selectedProduct.quantityInStock > 0
        ) {
          this.listBillItem.push(billItem);
          await this.fetchProductAttach(selectedProduct.productId, billItem.id);
        } else {
          makeToastFaile('Số sản phẩm tồn trong kho không đủ!');
        }
      }

      this.listBillItem = this.sortListBillItem(this.listBillItem);
      this.optionsProduct[0].data = [];
      if (this.getInstallmentInterestZero) {
        // this.fetchProgramByProductIds(this.getInstallmentInterestZero);
      }
    },
    onInputChangProduct(text) {
      this.optionsProduct[0].data = [];
      this.filteredOptionsProduct = [
        {
          data: this.optionsProduct[0].data,
        },
      ];
      if (!text) {
        text = '';
        this.productLoading = false;
        return;
      }
      this.productLoading = true;
      this.searchProduct = text.trim();
      this.debounceInputProduct();
    },
    debounceInputProduct: decounce(function () {
      if (this.searchProduct) {
        this.searchProductAPI();
      }
    }, TIME_TRIGGER),
    searchProductAPI() {
      if (!this.isSearching) {
        const textSearch = this.searchProduct ? this.searchProduct.trim() : '';
        if (!textSearch) {
          return;
        }
        if (this.selectTypeSearch === PRODUCT_SEARCH_TYPE.PRODUCT_NAME) {
          this.fetchProduct(textSearch);
          // } else if (
          //   this.selectTypeSearch === PRODUCT_SEARCH_TYPE.FLEXIBLE_COMBO
          // ) {
          //   this.searchFlexibleCombo(textSearch);
        } else if (
          this.selectTypeSearch === PRODUCT_SEARCH_TYPE.CHASSIS_ENGINE
        ) {
          this.fetchProductChassisNumber(textSearch);
        } else if (this.selectTypeSearch === PRODUCT_SEARCH_TYPE.SERIAL) {
          this.fetchProductSerial(textSearch);
        }
      }
    },
    fetchProduct(textSearch) {
      this.isSearching = true;
      this.optionsProduct[0].data = [];
      const params = {
        storeId: this.mainModel.storeId,
        productName: textSearch,
        // isInterestZero: this.getInstallmentInterestZero,
      };

      // const url = params.isInterestZero
      //   ? 'products/search'
      //   : 'productSearch';
      const url = 'products/search';

      ApiService.query(url, {
        params,
      }).then(({ data }) => {
        const products = data.data;
        this.optionsProduct[0].data = products.map((product) => {
          return Object.assign({}, new ProductSearchOption(product));
        });
        this.filteredOptionsProduct = [
          {
            data: this.optionsProduct[0].data,
          },
        ];
        this.isSearching = false;
        this.productLoading = false;
        if (textSearch !== this.searchProduct) {
          this.searchProductAPI();
        }
      });
    },
    fetchProductChassisNumber(textSearch) {
      this.isSearching = true;
      this.optionsProduct[0].data = [];
      ApiService.get(
        `products/search/chassis-number?chassisNumber=${textSearch}&storeId=${this.mainModel.storeId}`,
      ).then(({ data }) => {
        const products = data.data;
        this.optionsProduct[0].data = products.map((product) =>
          Object.assign({}, new ProductSearchOption(product)),
        );
        this.filteredOptionsProduct = [
          {
            data: this.optionsProduct[0].data,
          },
        ];
        this.isSearching = false;
        this.productLoading = false;
        if (textSearch !== this.searchProduct) {
          this.searchProductAPI();
        }
      });
    },

    fetchProductSerial(textSearch) {
      this.isSearching = true;
      this.optionsProduct[0].data = [];
      ApiService.get(
        `products/search/serial-number?serialNumber=${textSearch}&storeId=${this.mainModel.storeId}`,
      ).then(({ data }) => {
        const products = data.data;
        this.optionsProduct[0].data = products.map((product) =>
          Object.assign({}, new ProductSearchOption(product)),
        );
        this.filteredOptionsProduct = [
          {
            data: this.optionsProduct[0].data,
          },
        ];
        this.isSearching = false;
        this.productLoading = false;
        if (textSearch !== this.searchProduct) {
          this.searchProductAPI();
        }
      });
    },
    changePlaceholder() {
      if (this.selectTypeSearch === PRODUCT_SEARCH_TYPE.PRODUCT_NAME) {
        this.inputSearchProductProp.placeholder =
          'Tìm kiếm theo tên, mã, mã vạch sản phẩm';
      } else if (this.selectTypeSearch === PRODUCT_SEARCH_TYPE.CHASSIS_ENGINE) {
        this.inputSearchProductProp.placeholder =
          'Tìm kiếm theo số khung sản phẩm';
      } else if (this.selectTypeSearch === PRODUCT_SEARCH_TYPE.SERIAL) {
        this.inputSearchProductProp.placeholder =
          'Tìm kiếm theo serial sản phẩm';
      }
      this.optionsProduct[0].data = [];
      this.debounceInputProduct();
    },
    // async fetchShiftWorkConfig() {
    //   if (this.mainModel.storeId) {
    //     const params = {
    //       storeId: this.mainModel.storeId,
    //       billCreatedAt: this.mainModel.billCreatedAt
    //         ? this.mainModel.billCreatedAt
    //         : null,
    //     };
    //     ApiService.query('shift-work-config/getByStore', { params })
    //       .then(({ data }) => {
    //         this.shiftWorkConfig = data.data;
    //         for (const jobTitle in this.mainModel.billEmployeeInfo) {
    //           if (!this.mainModel.billEmployeeInfo[jobTitle]) {
    //             if (jobTitle !== 'saleId' && jobTitle !== 'saleName') {
    //               this.mainModel.billEmployeeInfo[jobTitle] =
    //                 this.shiftWorkConfig[jobTitle];
    //             }
    //           }
    //         }
    //       })
    //       .catch(({ response }) => {
    //         makeToastFaile(response.$error);
    //       });
    //   }
    // },

    onStoreSelected(storeId) {
      this.mainModel.storeId = storeId;
      this.resetEmployData();
      // this.fetchShiftWorkConfig();
      this.inputSearchProductProp.disabled = false;
      this.listBillItem = [];
    },
    isExistChassisEngine(listProduct, chassisNumber, engineNumber) {
      const existed = listProduct.find(
        (x) =>
          x.chassisNumber === chassisNumber || x.engineNumber === engineNumber,
      );
      return existed ? true : false;
    },

    isExistSerialNumber(listProduct, serialNumber) {
      const existed = listProduct.find((x) => x.serialNumber === serialNumber);
      return existed ? true : false;
    },
    async checkInsProgramByProductId(productId) {
      const params = {
        productId: productId,
      };

      return ApiService.query(`installment-programs/product`, {
        params,
      }).then(({ data }) => {
        const product = data.data;
        return product;
      });
    },
    showWarning(text) {
      return Swal.fire({
        title: 'Trả góp 0%!',
        text: `${text}`,
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: 'rgb(221, 51, 51)',
        confirmButtonText: 'Đồng ý',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      });
    },
    sortListBillItem(listBillItem) {
      // Turn off mapping for related bill item mapping
      //   const listResult = [];
      //   const mainItems = listBillItem.filter(
      //     (item) => item.billItemType === BILL_ITEM_TYPE.PRODUCT,
      //   );
      //   const attachItems = listBillItem.filter(
      //     (item) => item.billItemType !== BILL_ITEM_TYPE.PRODUCT,
      //   );

      //   mainItems.forEach((billItem, index) => {
      //     billItem.stt = index + 1;
      //     listResult.push(billItem);

      //     let belongBillItems = attachItems.filter(
      //       (item) => item && item.belongBillDetailId === billItem.id,
      //     );

      //     belongBillItems = sortBy(belongBillItems, ['billItemType']);
      //     belongBillItems.forEach((attachItem) => {
      //       if (attachItem) {
      //         listResult.push(attachItem);
      //       }
      //     });
      //   });

      return listBillItem;
    },

    async fetchProductAttach(productId, parentId) {
      // Dùng chung 2 endpoint với ĐN/HĐMB: gifts (auto) + promotions (modal).
      const storeId = this.mainModel.storeId;
      Promise.all([
        ApiService.post('accessories/resolve-attached-gifts', {
          productIds: [productId],
          storeId,
        }),
        ApiService.post('accessories/resolve-attached-promotions', {
          productIds: [productId],
          storeId,
        }),
      ]).then(([giftRes, promoRes]) => {
        //response data
        const item = {
          listAccessoryBonus: giftRes?.data?.data?.[productId] || [],
          listAccessoryPromotion: promoRes?.data?.data?.[productId] || [],
        };
        //mapping data to main item
        const billItem = this.listBillItem.find((item) => item.id === parentId);
        if (!billItem) {
          return;
        }
        //gift
        billItem.listAccessoryBonus = item.listAccessoryBonus;
        item.listAccessoryBonus.forEach((element) => {
          const code = `Quà tặng kèm- ${element.accessoryGroupCode}`;

          const giftItem = {
            id: v4(),
            productId: element.productId,
            name: element.productName,
            productNameVat: element.productNameVat,
            code: code,
            price: element.sellingPrice,
            quantity: 1,
            type: element.productType,
            imeiCode: '',
            totalPrice: element.sellingPrice,
            discount: '',
            quantityInStock: element.quantityInStock,
            storeId: this.selectedClassStore,
            billItemType: BILL_ITEM_TYPE.PRODUCT_BONUS,
            checked: true,
            belongBillDetailId: parentId,
            returnPrice: element.price,
            accessoryGroupId: element.accessoryGroupId,
            accessoryGroupCode: element.accessoryGroupCode,
            listProductVariant: element.listProductVariant,
            isGetVat: false,
          };
          this.listBillItem.push(giftItem);
        });

        //attach
        billItem.listAccessoryPromotion = item.listAccessoryPromotion;

        this.listBillItem = this.sortListBillItem(this.listBillItem);
      });
    },
    deleteBillItem(id) {
      this.listBillItem = this.listBillItem.filter(
        (billItem) => billItem.id !== id && billItem.belongBillDetailId !== id,
      );

      this.listBillItem = this.sortListBillItem(this.listBillItem);
    },
    changeCouponCode() {
      if (
        this.isValidCoupon === true &&
        this.mainModel.couponCode !== this.validCouponCode
      ) {
        this.isValidCoupon = false;
        this.stateCouponCode = null;
      }
    },
    checkCoupon() {
      if (this.listBillItem.length <= 0) {
        makeToastFaile('Bạn chưa chọn sản phẩm nào');
        return;
      }
      const billItems = this.formatListBillItem();
      const data = {
        storeId: this.mainModel.storeId,
        listProduct: billItems,
        couponCode: this.mainModel.couponCode,
        customerId: this.mainModel.customerModel.customerId,
      };
      this.onSubmiting = true;
      ApiService.post('coupon/check-coupon', data)
        .then(({ data }) => {
          this.onSubmiting = false;
          if (data.status === 1) {
            makeToastSuccess(data.message);
            if (data.data !== null) {
              this.mainModel.discountAmount = data.data.amount;
              this.couponValue = data.data.amount;
              this.mainModel.discountType = DISCOUNT_AMOUNT_TYPE.MONEY;
              this.isValidCoupon = true;
              this.validCouponCode = this.mainModel.couponCode;
              this.stateCouponCode = true;
            }
          } else {
            this.stateCouponCode = false;
            makeToastFaile(data.message);
          }
        })
        .catch(({ response }) => {
          this.onSubmiting = false;
          console.log('response :>> ', response);
          makeToastFaile(response.data.message || 'Lỗi');
        });
    },
    showGiftModal(billItemId) {
      this.selectedBillItem.billItemId = billItemId;
      const billItem = this.listBillItem.find((item) => item.id === billItemId);
      this.selectedBillItem.productName = billItem ? billItem.name : '';
      this.selectedBillItem.productId = billItem ? billItem.productId : null;
      // Quà đã gắn dưới dòng này → modal disable, tránh thêm trùng.
      this.selectedBillItem.attachedGiftProductIds = this.listBillItem
        .filter(
          (it) =>
            it.belongBillDetailId === billItemId &&
            it.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS,
        )
        .map((it) => it.productId);
      setTimeout(() => {
        this.$refs['bill-gift-modal'].showModal();
      }, TIME_TRIGGER);
    },
    addGift(gifts) {
      // Loại quà trùng đã có dưới cùng dòng chính (an toàn 2 lớp với modal).
      const existingKeys = new Set(
        this.listBillItem
          .filter((it) => it.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS)
          .map((it) => `${it.belongBillDetailId}|${it.productId}`),
      );
      const fresh = (gifts || []).filter(
        (g) => !existingKeys.has(`${g.belongBillDetailId}|${g.productId}`),
      );
      this.listBillItem = this.listBillItem.concat(fresh);
      this.listBillItem = this.sortListBillItem(this.listBillItem);
    },
    async showAttachModal(billItemId) {
      this.selectedBillItem.billItemId = billItemId;
      const billItem = this.listBillItem.find((item) => item.id === billItemId);
      this.selectedBillItem.productName = billItem ? billItem.name : '';
      if (this.productAttach[billItem.productId]) {
        this.selectedBillItem.attachItems =
          this.productAttach[billItem.productId];
      } else {
        try {
          const { data } = await ApiService.post(
            'accessories/resolve-attached-promotions',
            { productIds: [billItem.productId], storeId: billItem.storeId },
          );
          const listAccessoryPromotion =
            (data && data.data && data.data[billItem.productId]) || [];
          this.selectedBillItem.attachItems = listAccessoryPromotion;
          this.productAttach[billItem.productId] = listAccessoryPromotion;
        } catch (error) {
          return makeToastFaile(error.message);
        }
      }

      setTimeout(() => {
        this.$refs['bill-attach-modal'].showModal();
      }, TIME_TRIGGER);
    },
    addAttach(attachs) {
      this.listBillItem = this.listBillItem.concat(attachs);
      this.listBillItem = this.sortListBillItem(this.listBillItem);
    },
    showWarrantyModal(productId) {
      const billItem = this.listBillItem.find(
        (item) => item.productId === productId,
      );
      this.selectedBillItem.productName = billItem ? billItem.name : '';
      this.selectedBillItem.productId = productId;
      setTimeout(() => {
        this.$refs['bill-warranty-modal'].showModal();
      }, TIME_TRIGGER);
    },
    addWarranty(warrantyItems) {
      const listItem = warrantyItems.map((item) => {
        return {
          id: v4(),
          stt: 0,
          productId: item.id,
          name: item.productName,
          productNameVat: '',
          code: item.productCode,
          price: item.sellingPrice,
          type: 4,
          quantity: 1,
          imeiCode: '',
          discount: 0,
          quantityInStock: 0,
          storeId: this.mainModel.storeId,
          comboItems: [],
          billItemType: BILL_ITEM_TYPE.PRODUCT,
          checked: true,
          listAccessoryPromotion: [],
          returnPrice: 0,
          accessoryGroupId: '',
          accessoryGroupCode: '',
          note: '',
          discountType: AMOUNT_TYPE.PERCENT,
          discountProgramId: -1,
          isGetVat: false,
          sellingPrice: item.sellingPrice,
        };
      });
      this.listBillItem = this.listBillItem.concat(listItem);
      this.listBillItem = this.sortListBillItem(this.listBillItem);
    },
    checkValidImei(value) {
      this.isValidImei = value;
    },
    updateItem(item) {
      this.listBillItem.forEach((element, index) => {
        if (element.id === item.id) {
          this.listBillItem[index].name = item.name;
          this.listBillItem[index].imeiCode = item.imeiCode;
          this.listBillItem[index].productId = item.productId;
          this.listBillItem[index].price = item.price
            ? unMaskPrice(item.price)
            : 0;
          this.listBillItem[index].quantity = item.quantity
            ? unMaskPrice(item.quantity)
            : 0;
          this.listBillItem[index].discount = item.discount
            ? unMaskPrice(item.discount)
            : 0;
          this.listBillItem[index].note = item.note;
          this.listBillItem[index].discountType = item.discountType;
          this.listBillItem[index].discountProgramId = item.discountProgramId;
          this.listBillItem[index].vouchers = item.vouchers;
        }
      });
      this.$forceUpdate();
    },
    showChangeGiftModal(billItemId) {
      const billItem = this.listBillItem.find((item) => item.id === billItemId);
      this.selectedBillItem.listProductVariant = billItem
        ? billItem.listProductVariant
        : [];
      this.selectedBillItem.productId = billItem ? billItem.productId : null;
      this.selectedBillItem.billItemId = billItem.id;
      setTimeout(() => {
        this.$refs['change-gift-modal'].showModal();
      }, TIME_TRIGGER);
    },
    onChangeGift(productId) {
      const productSelected = this.selectedBillItem.listProductVariant.find(
        (variant) => variant.productId === productId,
      );
      const billItem = this.listBillItem.find(
        (item) => item.id === this.selectedBillItem.billItemId,
      );
      billItem.productId = productSelected.productId;
      billItem.name = productSelected.productName;
      billItem.productNameVat = productSelected.productNameVat;
    },
    showNoteModal(billItemId) {
      const billItem = this.listBillItem.find((item) => item.id === billItemId);
      this.selectedBillItem.productName = billItem ? billItem.name : '';
      this.selectedBillItem.note = billItem ? billItem.note : '';
      this.selectedBillItem.billItemId = billItemId;
      setTimeout(() => {
        this.$refs['bill-note-modal'].showModal();
      }, TIME_TRIGGER);
    },
    onChangeNote(note) {
      const billItem = this.listBillItem.find(
        (item) => item.id === this.selectedBillItem.billItemId,
      );
      billItem.note = note;
    },
    showModalShiftWorkConfig() {
      this.shiftWorkConfigSelected = {
        storeName: this.mainModel.storeName,
        storeId: this.mainModel.storeId,
        ...this.shiftWorkConfig,
      };
    },
    showListImeiModal(billItemId) {
      const billItem = this.listBillItem.find((item) => item.id === billItemId);
      this.selectedBillItem.productName = billItem ? billItem.name : '';
      this.selectedBillItem.productId = billItem ? billItem.productId : null;
      this.selectedBillItem.billItemId = billItem.id;
      setTimeout(() => {
        this.$refs['list-imei-modal'].showModal(
          this.selectedBillItem.productId,
        );
      }, TIME_TRIGGER);
    },
    showListChassisEngineModal(billItemId) {
      const billItem = this.listBillItem.find((item) => item.id === billItemId);
      this.selectedBillItem.productName = billItem ? billItem.name : '';
      this.selectedBillItem.productId = billItem ? billItem.productId : null;
      this.selectedBillItem.billItemId = billItem.id;
      setTimeout(() => {
        this.$refs['list-chassis-engine-modal'].showModal(
          this.selectedBillItem.productId,
        );
      }, TIME_TRIGGER);
    },
    showListSerialModal(billItemId) {
      const billItem = this.listBillItem.find((item) => item.id === billItemId);
      this.selectedBillItem.productName = billItem ? billItem.name : '';
      this.selectedBillItem.productId = billItem ? billItem.productId : null;
      this.selectedBillItem.billItemId = billItem.id;
      setTimeout(() => {
        this.$refs['list-serial-modal'].showModal(
          this.selectedBillItem.productId,
        );
      }, TIME_TRIGGER);
    },
    applyImei(imeiCode) {
      const billItem = this.listBillItem.find(
        (item) => item.id === this.selectedBillItem.billItemId,
      );
      billItem.imeiCode = imeiCode;
    },
    applyChassisEngine(data) {
      const billItemIndex = this.listBillItem.findIndex(
        (item) => item.id === this.selectedBillItem.billItemId,
      );

      if (billItemIndex !== -1) {
        const updatedBillItem = {
          ...this.listBillItem[billItemIndex],
          chassisNumber: data['chassisNumber'],
          engineNumber: data['engineNumber'],
          productChassisId: data['id'],
        };

        this.$set(this.listBillItem, billItemIndex, updatedBillItem);
      }
    },
    applySerialNumber(data) {
      const billItemIndex = this.listBillItem.findIndex(
        (item) => item.id === this.selectedBillItem.billItemId,
      );
      if (billItemIndex !== -1) {
        const updatedBillItem = {
          ...this.listBillItem[billItemIndex],
          serialNumber: data['serialNumber'],
          productSerialId: data['id'],
        };

        this.$set(this.listBillItem, billItemIndex, updatedBillItem);
      }
    },
    viewInventory(billItemId) {
      const billItem = this.listBillItem.find((item) => item.id === billItemId);
      if (billItem) {
        let nameRouter = '';
        if (billItem.type === 2) {
          nameRouter = 'inventory-detail-imei';
        } else {
          nameRouter = 'inventory-detail';
        }
        const { href } = this.$router.resolve({
          name: nameRouter,
          query: {
            id: billItem.productId,
          },
        });
        window.open(href, '_blank');
      }
    },
    isValidImeiCode(listBillItem) {
      let check = true;
      for (let index = 0; index < listBillItem.length; index++) {
        const element = listBillItem[index];
        if (
          element.type === PRODUCT_TYPE.PRODUCT_IMEI &&
          element.checked === true
        ) {
          if (!element.imeiCode || !element.imeiCode.trim()) {
            check = false;
            break;
          }
        }
      }
      return check;
    },
    onSubmit: async function (mode = 'save') {
      this.onSubmiting = true;

      const listProductsHaveZeroQuantity = this.listBillItem.filter(
        (item) => Number(item.quantity) === 0,
      );
      if (listProductsHaveZeroQuantity.length) {
        this.onSubmiting = false;
        return makeToastFaile('Số lượng các sản phẩm phải lớn hơn 0');
      }

      if (!this.mainModel.storeId) {
        this.onSubmiting = false;
        return makeToastFaile('Vui lòng chọn cửa hàng!');
      }

      if (!this.listBillItem.length) {
        this.onSubmiting = false;
        return makeToastFaile('Bạn chưa chọn sản phẩm nào');
      }
      if (!this.isValidImei) {
        this.onSubmiting = false;
        //kt lại 1 lần nữa xem IMEI có hợp lệ ko
        makeToastFaile('Mã IMEI không hợp lệ để bán!');
        this.isValidImei = true;
        return;
      }
      if (!this.isValidImeiCode(this.listBillItem)) {
        this.onSubmiting = false;
        return makeToastFaile('Vui lòng nhập IMEI cho sản phẩm IMEI');
      }
      if (
        this.prevSubtractPoint !== this.mainModel.subtractPoint &&
        !this.mainModel.isSubtractPointValidated
      ) {
        this.onSubmiting = false;
        return makeToastFaile('Vui lòng xác thực tiêu điểm tích lũy!');
      }

      if (this.mainModel.couponCode) {
        if (
          this.prevCouponCode !== this.mainModel.couponCode &&
          !this.isValidCoupon
        ) {
          this.onSubmiting = false;
          return makeToastFaile('Vui lòng xác thực mã coupon!');
        }
      }

      const billData = this.setBillData();

      // check creditFeeAmount
      if (billData.creditAmount === 0) {
        billData.otherFees = 0;
      }

      if (billData.isInterestZero && billData.listBillItem.length > 1) {
        this.onSubmiting = false;
        return makeToastFaile(
          'Chương trình trả góp 0% chỉ áp dụng cho 1 sản phẩm',
        );
      }

      this.onPaymentSubmiting = false;
      const errorPayments = this.validatePayment(billData);

      if (errorPayments.length) {
        this.onPaymentSubmiting = true;
        this.onSubmiting = false;
        return makeToastFailHtml(this, errorPayments);
      }

      // KH doanh nghiệp: search theo MST, KHÔNG bắt nhập SĐT (SĐT tự lấy từ DN
      // nếu có). Thay vào đó yêu cầu đã chọn/nhập MST. KH lẻ: SĐT vẫn bắt buộc.
      if (this.mainModel.customerModel.customerKind === 'BUSSINESS') {
        if (!this.mainModel.customerModel.customerMst) {
          this.onSubmiting = false;
          return makeToastFaile('Vui lòng chọn doanh nghiệp (mã số thuế)!');
        }
      } else if (!billData.customerPhone) {
        this.onSubmiting = false;
        return makeToastFaile('Vui lòng nhập thông tin khách hàng hợp lệ!');
      }

      // KH doanh nghiệp ẩn Danh xưng (giống HĐMB) → không validate required.
      if (
        this.mainModel.customerModel.customerKind !== 'BUSSINESS' &&
        !billData.customerGender
      ) {
        this.onSubmiting = false;
        return makeToastFaile('Vui lòng nhập danh xưng khách hàng!');
      }

      if (!this.isValidTaxCode) {
        this.onSubmiting = false;
        return makeToastFaile('Mã số thuế không hợp lệ!');
      }

      if (!this.isValidEmail) {
        this.onSubmiting = false;
        return makeToastFaile('Email không hợp lệ!');
      }

      if (this.totalAmountBeforeDiscount < billData.discountAmount) {
        this.onSubmiting = false;
        return makeToastFaile(
          'Số tiền chiết khấu không nên cao hơn số tiền sản phẩm',
        );
      }

      const missingEngineChassis = (this.listBillItem || [])
        .filter(
          (it) =>
            it &&
            it.productChassisId &&
            this.isEnginePlaceholder(it.engineNumber),
        )
        .map((it) => it.chassisNumber || it.productChassisId);
      if (missingEngineChassis.length) {
        this.onSubmiting = false;
        return makeToastFaile(
          `Sản phẩm có SK: ${missingEngineChassis.join(
            ', ',
          )} chưa cập nhật số máy, vui lòng cập nhật trước khi tạo hóa đơn`,
        );
      }
      // Persist field pháp lý KH (CCCD/Email/Ngày sinh) trước khi lưu bill.
      await this.persistBillCustomerLegal();

      if (!this.mainModel.id) {
        if (!this.mainModel.orderId && this.orderNotComplete) {
          await this.showWarningOrderNotComplete(billData);
        } else {
          this.onCallApiCreate(billData);
        }
      } else {
        this.onCallApiUpdate(billData, mode);
      }
    },
    onCallApiCreate: async function (billData) {
      const url = this.mainModel.fromBillNumber
        ? `bills/re-create/${this.mainModel.fromBillNumber}`
        : 'bills';

      await ApiService.post(url, billData)
        .then(async ({ data }) => {
          if (data.status === 1) {
            makeToastSuccess(data.message);
            this.mainModel.billNumber = data.data.billNumber;
            this.$router.push({
              path: '/bills',
            });
          } else {
            makeToastFaile(data.message);
            this.onSubmiting = false;
          }
        })
        .catch((err) => {
          if (!err.response) {
            // network error
            makeToastFaile(err.$error);
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
          this.onSubmiting = false;
        });
    },
    onCallApiUpdate: async function (billData, mode = 'save') {
      await ApiService.put('bills', billData)
        .then(async ({ data }) => {
          if (data.status === 1) {
            makeToastSuccess(data.message);
            if (mode === 'save-print') {
              this.$router.push({
                name: 'print-bill',
                query: { id: billData.billNumber },
              });
            } else {
              this.$router.push({
                path: '/bills',
              });
            }
            this.onSubmiting = false;
          } else {
            makeToastFaile(data.message);
            this.onSubmiting = false;
          }
        })
        .catch((err) => {
          if (!err.response) {
            // network error
            makeToastFaile(err.$error);
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
          this.onSubmiting = false;
        });
    },
    setBillData() {
      const billItems = this.formatListBillItem();

      const transferAmount = this.calcPaymentsAmount(this.mainModel.transfer);
      const creditAmount = this.calcPaymentsAmount(this.mainModel.credits);
      const cashAmount = this.calcPaymentsAmount(this.mainModel.cash);
      const installmentAmount = this.calcPaymentsAmount(
        this.mainModel.installments,
      );
      const data = {
        type: BILL_TYPE.RETAIL,
        storeId: this.mainModel.storeId,
        discountType: this.mainModel.discountType,
        discountAmount: this.mainModel.discountAmount
          ? unMaskPrice(this.mainModel.discountAmount)
          : 0,
        discountCouponCode: this.mainModel.couponCode,
        shipFee: this.mainModel.customerShipFee,
        saleNote: this.mainModel.billNote.saleNote,
        saleId: this.mainModel.billEmployeeInfo.saleId,
        technicalId: this.mainModel.billEmployeeInfo.technicalId,
        cashierId: this.mainModel.billEmployeeInfo.cashierId,
        managerId: this.mainModel.billEmployeeInfo.managerId,
        assistantId: this.mainModel.billEmployeeInfo.assistantId,
        receptionId: this.mainModel.billEmployeeInfo.customerReceptionId,
        shipperId: this.mainModel.billEmployeeInfo.shipperId,
        customerId: this.mainModel.customerModel.customerId,
        customerPhone: this.mainModel.customerModel.customerMobile?.trim(),
        customerName: this.mainModel.customerModel.customerName?.trim(),
        customerGender: this.mainModel.customerModel.customerAppellation,
        // customerEmail: this.mainModel.customerModel.customerEmail.trim(),
        customerAddress: this.mainModel.customerModel.customerAddress?.trim(),
        customerType: this.mainModel.customerModel.customerKind || 'CUSTOMER',
        customerMst:
          this.mainModel.customerModel.customerKind === 'BUSSINESS'
            ? this.mainModel.customerModel.customerMst || null
            : null,
        customerRepresentative:
          this.mainModel.customerModel.customerKind === 'BUSSINESS'
            ? this.mainModel.customerModel.customerRepresentative || null
            : null,
        customerBusinessId:
          this.mainModel.customerModel.customerKind === 'BUSSINESS'
            ? this.mainModel.customerModel.customerBusinessId || null
            : null,
        customerIndentifyNo: this.mainModel.installments[0].customerIndentifyNo,
        customerNote: this.mainModel.billNote.customerNote,
        creditAccountId: this.mainModel.credits[0].accountId,
        creditAmount: creditAmount,
        credits: creditAmount > 0 ? this.mainModel.credits : [],
        cashAccountId: this.mainModel.cash[0].accountId,
        cashAmount: cashAmount,
        cash: this.mainModel.cash,
        transferAccountId: this.mainModel.transfer[0].accountId,
        transferAmount: transferAmount,
        transfers: transferAmount > 0 ? this.mainModel.transfer : [],
        installmentAccountId: this.mainModel.installments[0].accountId,
        installmentAmount: installmentAmount,
        installments: installmentAmount > 0 ? this.mainModel.installments : [],
        refunds: this.mainModel.refunds,
        warrantyNote: this.mainModel.billNote.warrantyNote,
        billItems: billItems,
      };
      if (this.mainModel.billNumber) {
        data['id'] = this.mainModel.id;
      }
      if (this.mainModel.contractId) {
        data['contractId'] = this.mainModel.contractId;
      }

      return data;
    },
    // setBillData() {
    //   const billItems = this.formatListBillItem();
    //   this.transferAmount = this.calcPaymentsAmount(this.mainModel.transfer);
    //   return {
    //     id: this.mainModel.id,
    //     billNumber: this.mainModel.billNumber || null,
    //     storeId: this.mainModel.storeId,
    //     stockSlipId: this.mainModel.stockSlipId,
    //     //khach hang
    //     customerId: this.mainModel.customerModel.customerId,
    //     customerMobile: this.mainModel.customerModel.customerMobile.trim(),
    //     customerName: this.mainModel.customerModel.customerName.trim(),
    //     customerAddress: this.mainModel.customerModel.customerAddress,
    //     customerCity: this.mainModel.customerModel.customerCity,
    //     customerDistrict: this.mainModel.customerModel.customerDistrict,
    //     customerWard: this.mainModel.customerModel.customerWard,
    //     customerLastName: this.mainModel.customerModel.customerLastName,
    //     customerAppellation: this.mainModel.customerModel.customerAppellation,
    //     orderSourceId: this.mainModel.orderSourceId,
    //     //khach hang bao hanh
    //     warrantyCustomerId: this.mainModel.warrantyCustomerModel.customerId,
    //     warrantyCustomerName: this.mainModel.warrantyCustomerModel.customerName,
    //     warrantyCustomerPhone:
    //       this.mainModel.warrantyCustomerModel.customerMobile,
    //     warrantyCustomerLastName:
    //       this.mainModel.warrantyCustomerModel.customerLastName,
    //     //nhan vien
    //     saleId: this.mainModel.billEmployeeInfo.saleId,
    //     technicalId: this.mainModel.billEmployeeInfo.technicalId,
    //     accessoryStaffId: this.mainModel.billEmployeeInfo.accessoryStaffId,
    //     cashierId: this.mainModel.billEmployeeInfo.cashierId,
    //     managerId: this.mainModel.billEmployeeInfo.managerId,
    //     assistantId: this.mainModel.billEmployeeInfo.assistantId,
    //     customerReceptionId:
    //       this.mainModel.billEmployeeInfo.customerReceptionId,
    //     shipperId: this.mainModel.billEmployeeInfo.shipperId,
    //     //ghi chu
    //     customerNote: this.mainModel.billNote.customerNote,
    //     saleNote: this.mainModel.billNote.saleNote,
    //     warrantyNote: this.mainModel.billNote.warrantyNote,
    //     //chiet khau
    //     discountType: this.mainModel.discountType,
    //     discountAmount: this.mainModel.discountAmount
    //       ? unMaskPrice(this.mainModel.discountAmount)
    //       : 0,
    //     listBillItem: billItems,
    //     orderId: this.mainModel.orderId,
    //     //hoa don do
    //     vatCompanyName: this.mainModel.vatInvoice.companyName,
    //     vatCompanyAddress: this.mainModel.vatInvoice.companyAddress,
    //     vatCompanyType: this.mainModel.vatInvoice.vatCompanyType,
    //     email: this.mainModel.vatInvoice.email,
    //     taxCode: this.mainModel.vatInvoice.taxCode,
    //     //tieu diem
    //     pointUse: this.mainModel.subtractPoint
    //       ? unMaskPrice(this.mainModel.subtractPoint)
    //       : 0,
    //     isSubtractPointValidated: this.mainModel.isSubtractPointValidated,
    //     isCountPoint: this.mainModel.isCountPoint,
    //     //coupon
    //     isValidCouponCode: this.isValidCoupon,
    //     couponCode: this.mainModel.couponCode,
    //     //chuong trinh tra gop
    //     installmentProgramId: this.getInstallmentProgram.installmentProgramId,
    //     installmentProgramMonthNo:
    //       this.getInstallmentProgram.installmentProgramMonthNo,
    //     installmentProgramPrepayPercent:
    //       this.getInstallmentProgram.installmentProgramPrepayPercent,
    //     conversionFee: this.calcConversionFee(this.mainModel.installments),
    //     installments: this.mainModel.installments,
    //     credits: this.mainModel.credits,
    //     transfer: this.mainModel.transfer,
    //     cash: this.mainModel.cash,
    //     refunds: this.mainModel.refunds,
    //     //tien mat
    //     cashAmount: this.calcPaymentsAmount(this.mainModel.cash),
    //     cashAccountId: this.mainModel.cash[0].paymentRefId,
    //     cashAccountCode: null,
    //     //chuyen khoan
    //     transferAmount: this.transferAmount,
    //     transferAccountID: this.mainModel.transfer[0].paymentRefId,
    //     transferAccountCode: this.mainModel.transfer[0].paymentCode,
    //     transferReferenceCode: this.mainModel.transfer[0].paymentCode,
    //     //quet the
    //     creditAmount: this.calcPaymentsAmount(this.mainModel.credits),
    //     creditAccountId: this.mainModel.credits[0].paymentRefId,
    //     creditAccountCode: this.mainModel.credits[0].paymentCode,
    //     creditCode: this.mainModel.credits[0].paymentCode,
    //     creditCardNo: this.mainModel.credits[0].creditCardNo,
    //     //phi quet the
    //     otherFees: this.mainModel.paymentInfo.creditCardFee
    //       ? unMaskPrice(this.mainModel.paymentInfo.creditCardFee)
    //       : 0,
    //     payCreditFeeType: this.mainModel.paymentInfo.payCreditFeeType,
    //     creditFeeAccountId: this.mainModel.paymentInfo.creditFeeAccountantId,
    //     creditFeeAcountCode: this.mainModel.paymentInfo.creditFeeAcountCode,
    //     //tra gop
    //     installedMoneyAmount: this.calcPaymentsAmount(
    //       this.mainModel.installments,
    //     ),
    //     installMoneyAccountId: this.mainModel.installments[0].paymentRefId,
    //     installMoneyAccountCode: this.mainModel.installments[0].paymentCode,
    //     customerIndentifyNo: this.mainModel.installments[0].customerIndentifyNo,
    //     installMoneyCode: this.mainModel.installments[0].installMoneyCode,
    //     isInterestZero: this.getInstallmentInterestZero,
    //     billType: this.billType,
    //   };
    // },
    flattenFlexibleCombo(flexibleCombo) {
      return flexibleCombo.comboItems.map((comboItem) => {
        return {
          id: null,
          productId: comboItem.productId,
          productPrice: unMaskPrice(comboItem.sellingPrice),
          quantity: comboItem.quantity ? unMaskPrice(comboItem.quantity) : 1,
          discountAmount: comboItem.discountAmount
            ? unMaskPrice(comboItem.discountAmount)
            : 0,
          imeiCode: comboItem.imeiCode,
          productType: 1,
          accessoryGroupId: null,
          accessoryGroupCode: '',
          repurchasePrice: 0,
          isGiftTaken: true,
          note: '',
          gifts: [],
          attachs: [],
          discountType: AMOUNT_TYPE.MONEY,
          discountProgramId: null,
          issuedVat: true,
          flexibleComboId: flexibleCombo.flexibleComboId,
          flexibleComboItemId: comboItem.flexibleComboItemId,
        };
      });
    },
    calcConversionFee(installments) {
      return installments.reduce((result, currentItem) => {
        if (currentItem.child && !currentItem.child.deleted) {
          result += currentItem.child.paymentAmount || 0;
        }
        return result;
      }, 0);
    },
    calcPaymentsAmount(items) {
      return items.reduce((result, item) => {
        const unMask = unMaskPrice(item.paymentAmount) || 0;
        return result + Number(unMask);
      }, 0);
    },
    validatePayment(billData) {
      const payments = [
        billData.cash,
        billData.transfer,
        billData.credits,
        billData.installments,
        billData.refunds,
      ];
      const errorMessages = payments.flat().reduce((result, item) => {
        if (item && item.amount && !item.accountId) {
          result.push(
            `Tài khoản thanh toán số tiền ${convertPrice(
              item.amount,
            )} không hợp lệ`,
          );
        }
        return result;
      }, []);
      return errorMessages;
    },
    validatePayment2(billData) {
      const amounts = [
        billData.cashAmount,
        billData.transferAmount,
        billData.creditAmount,
        billData.otherFees,
      ];
      const accountIds = [
        billData.cashAccountId,
        billData.transferAccountID,
        billData.creditAccountId,
        billData.creditFeeAccountId,
      ];

      for (let index = 0; index < amounts.length; index++) {
        const amount = amounts[index];
        const accountId = accountIds[index];
        if (parseInt(amount) > 0 && !accountId) {
          this.onPaymentSubmiting = true;
          return false;
        }
      }
      this.onPaymentSubmiting = false;
      return true;
    },
    formatListBillItem() {
      return this.listBillItem.map((item) => {
        const response = {
          id: item['id'],
          productId: item['productId'],
          categoryId: item['categoryId'],
          productPrice: Number(unMaskPrice(item.price)),
          importPrice: Number(unMaskPrice(item.importPrice)) || 0,
          quantity: item['quantity'],
          discountType: item['discountType'],
          discountAmount: Number(unMaskPrice(item['discount'])) || 0,
          productChassisId: item['productChassisId'] || null,
          productSerialId: item['productSerialId'] || null,
          discountAllocation: item['discountAllocation'] || 0,
          type: item['billItemType'] || BILL_ITEM_TYPE.PRODUCT,
          isGiftTaken: Boolean(item.checked),
          belongBillDetailId: item.belongBillDetailId,
          vouchers: item.vouchers || [],
        };
        if (this.mainModel.billNumber) {
          response['id'] = item['id'];
        }
        return response;
      });
    },
    // formatListBillItem() {
    //   const mainItems = this.listBillItem.filter(
    //     (billItem) =>
    //       billItem.billItemType === BILL_ITEM_TYPE.PRODUCT &&
    //       !billItem.flexibleComboId,
    //   );
    //   const flexibleComboBillItems = this.listBillItem.filter(
    //     (billItem) =>
    //       billItem.billItemType === BILL_ITEM_TYPE.PRODUCT &&
    //       billItem.flexibleComboId,
    //   );
    //   const giftItems = this.listBillItem.filter(
    //     (item) => item.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS,
    //   );
    //   const attachItems = this.listBillItem.filter(
    //     (item) => item.billItemType === BILL_ITEM_TYPE.PRODUCT_PROMTION,
    //   );

    //   const giftItemFormated = this.convertBillItem(giftItems);
    //   const attachItemFormated = this.convertBillItem(attachItems);

    //   const mainProductItems = mainItems.map((billItem) => {
    //     const gifts = giftItemFormated.filter(
    //       (giftItem) => giftItem.belongBillDetailId === billItem.id,
    //     );
    //     const attachs = attachItemFormated.filter(
    //       (attchItem) => attchItem.belongBillDetailId === billItem.id,
    //     );

    //     return {
    //       id: billItem.id || null,
    //       productId: billItem.productId,
    //       productPrice: unMaskPrice(billItem.price),
    //       quantity: billItem.quantity ? unMaskPrice(billItem.quantity) : 1,
    //       totalAmount: billItem.totalAmount || 0,
    //       discountAmount: billItem.discount
    //         ? unMaskPrice(billItem.discount)
    //         : 0,
    //       imeiCode: billItem.imeiCode,
    //       productType: billItem.billItemType,
    //       accessoryGroupId: billItem.accessoryGroupId,
    //       accessoryGroupCode: billItem.accessoryGroupCode,
    //       repurchasePrice: billItem.returnPrice
    //         ? unMaskPrice(billItem.returnPrice)
    //         : 0,
    //       isGiftTaken: billItem.checked,
    //       note: billItem.note,
    //       gifts: gifts,
    //       attachs: attachs,
    //       discountType: billItem.discountType,
    //       discountProgramId: billItem.discountProgramId,
    //       issuedVat: billItem.isGetVat,
    //       merchantId: billItem.merchantId || 1,
    //       voucherId: billItem.voucherId || null,
    //       voucherDetailId: billItem.voucherDetailId || null,
    //       voucherCode: billItem.voucherCode || null,
    //     };
    //   });
    //   let flexibleComboProductItems = [];
    //   flexibleComboBillItems.forEach((flexibleComboBillItem) => {
    //     const flexibleComboTransformed = this.flattenFlexibleCombo(
    //       flexibleComboBillItem,
    //     );
    //     flexibleComboProductItems = flexibleComboProductItems.concat(
    //       flexibleComboTransformed,
    //     );
    //   });
    //   return mainProductItems.concat(flexibleComboProductItems);
    // },
    convertBillItem(items) {
      return items.map((billItem) => {
        return {
          id: billItem.id || null,
          productId: billItem.productId,
          productPrice: unMaskPrice(billItem.price),
          quantity: billItem.quantity ? unMaskPrice(billItem.quantity) : 1,
          discountAmount: billItem.discount
            ? unMaskPrice(billItem.discount)
            : 0,
          imeiCode: billItem.imeiCode,
          productType: billItem.billItemType,
          accessoryGroupId: billItem.accessoryGroupId,
          accessoryGroupCode: billItem.accessoryGroupCode,
          repurchasePrice: billItem.returnPrice
            ? unMaskPrice(billItem.returnPrice)
            : 0,
          isGiftTaken: billItem.checked,
          note: billItem.note,
          gifts: [],
          attachs: [],
          discountType: DISCOUNT_AMOUNT_TYPE.MONEY,
          discountProgramId: null,
          issuedVat: billItem.isGetVat,
          belongBillDetailId: billItem.belongBillDetailId,
          merchantId: billItem.merchantId || 1,
          checked: billItem.checked,
        };
      });
    },
    getPointRate() {
      ApiService.get(`pointSetting`).then(({ data }) => {
        this.pointSetting.rate = parseInt(data.data.pointRate);
        this.pointSetting.allowRoundToDown =
          data.data.allowAddPointRoundToDown === 1 ? true : false;
      });
    },
    // getListOrderSource() {
    //   ApiService.get(`orderSources/getAll`).then((data) => {
    //     this.listCustomerSource = data.data.data;
    //   });
    // },
    getOTP() {
      if (!this.onSubmiting) {
        this.onSubmiting = true;
        const otpPayload = {
          customerId: this.mainModel.customerModel.customerId,
          pointUse: this.mainModel.subtractPoint,
          phoneNumber: this.mainModel.customerModel.customerMobile,
        };
        ApiService.post('customerOTP/', otpPayload)
          .then(({ data }) => {
            this.onSubmiting = false;
            if (data.status === 1) {
              makeToastSuccess(data.message);
              if (data.data !== null) {
                this.mainModel.otpCode = '123456';
                this.stateOTP = false;
              }
            } else {
              makeToastFaile(data.message);
            }
          })
          .catch((response) => {
            this.onSubmiting = false;
            makeToastFaile(response.$error);
          });
      }
    },
    checkOTP() {
      if (!this.onSubmiting) {
        this.onSubmiting = true;
        const otpPayload = {
          customerId: this.mainModel.customerModel.customerId,
          pointUse: this.mainModel.subtractPoint
            ? unMaskPrice(this.mainModel.subtractPoint)
            : 0,
          otpCode: this.mainModel.otpCode,
        };
        ApiService.post('customerOTP/checkOTP', otpPayload)
          .then(({ data }) => {
            this.onSubmiting = false;
            if (data.status === 1) {
              makeToastSuccess(data.message);
              if (data.data !== null) {
                this.mainModel.totalAmountPoint = data.data;
                this.mainModel.isSubtractPointValidated = true;
                this.stateOTP = true;
              }
            } else {
              makeToastFaile(data.message);
              this.stateOTP = false;
            }
          })
          .catch(({ response }) => {
            this.onSubmiting = false;
            makeToastFaile(response.$error);
          });
      }
    },
    // Tiền KH đã thanh toán trên HĐ mua bán → set mainModel.moneyPrepaidContract
    // (chỉ để hiển thị + đối trừ vào "Khách cần trả", KHÔNG đẩy vào mảng payment input).
    // Nguồn chính: dataRes.paidAmount (net = Σ CASH+TRANSFER+CREDIT − Σ REFUND, do BE tính).
    // Fallback (BE chưa deploy field này): tự tính từ dataRes.payments.
    fetchContractPrepaid(contractId) {
      if (!contractId) {
        this.mainModel.moneyPrepaidContract = 0;
        return Promise.resolve();
      }
      return ApiService.get(`/contract/${contractId}`)
        .then((data) => {
          const dataRes = data?.data?.data || {};
          let prepaidContract = 0;
          if (typeof dataRes.paidAmount === 'number') {
            prepaidContract = dataRes.paidAmount;
          } else if (Array.isArray(dataRes.payments)) {
            const COUNT_TYPES = [
              PAYMENT_TYPE.CASH,
              PAYMENT_TYPE.TRANSFER,
              PAYMENT_TYPE.CREDIT,
            ];
            prepaidContract = dataRes.payments.reduce(
              (acc, { type, amount }) => {
                if (COUNT_TYPES.includes(type))
                  return acc + Number(amount || 0);
                if (type === PAYMENT_TYPE.REFUND)
                  return acc - Number(amount || 0);
                return acc;
              },
              0,
            );
          }
          this.mainModel.moneyPrepaidContract =
            prepaidContract > 0 ? prepaidContract : 0;
        })
        .catch(() => {
          this.mainModel.moneyPrepaidContract = 0;
        });
    },
    getContractById() {
      ApiService.get(`/contract/${this.mainModel.contractId}`).then((data) => {
        const dataRes = data.data.data;
        this.mainModel.contractNumber = dataRes.contractNumber;
        this.mainModel.storeId = dataRes.storeId;
        this.mainModel.storeName = dataRes?.store?.name || '';
        this.searchStore = dataRes?.store?.name;
        // Nếu HĐ không gán NVBH → để trống cả id lẫn name (tránh hiện tên nhưng saleId rỗng gây nhầm "đã có NVBH").
        this.mainModel.billEmployeeInfo.saleId = dataRes.saleId || null;
        this.mainModel.billEmployeeInfo.saleName = dataRes.saleId
          ? dataRes.saleName || ''
          : '';
        // Phase B — auto-fill 4 vai trò NV từ HĐMB sang bill. Tên column reuse 1:1.
        // Pattern giống Sale: nếu HĐ không có id → trống cả id lẫn name.
        const _carryRole = (idKey, nameKey) => {
          const id = dataRes[idKey] || null;
          this.mainModel.billEmployeeInfo[idKey] = id;
          this.mainModel.billEmployeeInfo[nameKey] = id
            ? dataRes[nameKey] || ''
            : '';
        };
        _carryRole('technicalId', 'technicalName');
        _carryRole('cashierId', 'cashierName');
        _carryRole('managerId', 'managerName');
        _carryRole('assistantId', 'assistantName');
        this.mainModel.customerModel.customerId = dataRes.customerId;
        this.mainModel.discountAmount = dataRes.totalDiscountAmount
          ? dataRes.totalDiscountAmount
          : 0;
        this.mainModel.discountType = dataRes.discountType;
        this.mainModel.customerModel.customerMobile = dataRes.customerPhone;
        this.mainModel.customerModel.customerAddress = dataRes.customerAddress;
        this.mainModel.customerModel.customerName = dataRes.customerName;
        this.mainModel.customerModel.customerAppellation = null;
        // Prefill từ HĐMB → carry phân loại KH (Doanh nghiệp/Cá nhân) + field DN.
        // Mirror pattern getBillById(); contract.findOne trả đủ cột root nên dataRes
        // có customerType/customerMst/customerRepresentative (PIT-F-015).
        this.mainModel.customerModel.customerKind =
          dataRes.customerType || 'CUSTOMER';
        this.mainModel.customerModel.customerMst = dataRes.customerMst || '';
        this.mainModel.customerModel.customerRepresentative =
          dataRes.customerRepresentative || '';
        // Carry HĐMB→Bill: link DN thật (ADDITIVE — customerId vẫn theo SĐT).
        this.mainModel.customerModel.customerBusinessId =
          dataRes.customerBusinessId || null;
        this.mainModel.billEmployeeInfo.shipperId = dataRes.shipperId || null;
        this.mainModel.billEmployeeInfo.shipperName = dataRes.shipperId
          ? dataRes.shipperName || ''
          : '';

        // Tiền KH đã thanh toán trên HĐ mua bán → đối trừ vào "Khách cần trả".
        // dataRes ở đây đã có sẵn paidAmount/payments → set trực tiếp, khỏi gọi lại API.
        let prepaidContract = 0;
        if (typeof dataRes?.paidAmount === 'number') {
          prepaidContract = dataRes.paidAmount;
        } else if (Array.isArray(dataRes?.payments)) {
          const COUNT_TYPES = [
            PAYMENT_TYPE.CASH,
            PAYMENT_TYPE.TRANSFER,
            PAYMENT_TYPE.CREDIT,
          ];
          prepaidContract = dataRes.payments.reduce((acc, { type, amount }) => {
            if (COUNT_TYPES.includes(type)) return acc + Number(amount || 0);
            if (type === PAYMENT_TYPE.REFUND) return acc - Number(amount || 0);
            return acc;
          }, 0);
        }
        this.mainModel.moneyPrepaidContract =
          prepaidContract > 0 ? prepaidContract : 0;
        this.listBillItem = dataRes.contractDetail.flatMap((item) => {
          const main = {
            id: item.id,
            productId: item.productId,
            name: item.product.name,
            productNameVat: item.productNameVat,
            code: item.product.code,
            price: item.productPrice,
            type: item.product.type,
            quantity: item.quantity,
            //todo
            // imeiCode: item.imeiCode,
            productChassisId: item.productChassisId,
            productSerialId: item.productSerialId,

            chassisNumber: item?.productChassis?.chassisNumber || null,
            engineNumber: item?.productChassis?.engineNumber || null,
            serialNumber: item?.productSerial?.serialNumber || null,
            totalPrice: +item.totalAmount,
            totalAmount: +item.totalAmount,
            discount: Number(item.discountAmount) || 0,
            discountAmount: Number(item.discountAmount) || 0,
            comboItems: item.listProductInCombo,
            billItemType: BILL_ITEM_TYPE.PRODUCT,
            checked: item.isGiftTaken === null ? true : item.isGiftTaken,
            returnPrice: item.repurchasePrice ? item.repurchasePrice : 0,
            accessoryGroupId: item.accessoryGroupId
              ? item.accessoryGroupId
              : '',
            accessoryGroupCode: item.accessoryGroupCode
              ? item.accessoryGroupCode
              : '',
            note: item.note,
            belongBillDetailId: item.belongBillDetailId,
            listAccessoryPromotion: item.listProductPromotion,
            quantityInStock: item?.product?.productStock.length
              ? item?.product?.productStock[0]['inStockQuantity']
              : 0,
            storeId: dataRes.storeId,
            discountType: item.discountType,
            discountProgramId: item.discountProgramId,
            isGetVat: item.issuedVat === 1 ? true : false,
            disabledByInstallmentProgram: this.applyInstallmentProgram
              ? true
              : false,
            isInstallmentProgramProduct: this.applyInstallmentProgram
              ? true
              : false,
            sellingPrice: item.sellingPrice || 0,
            listedPrice: item.listedPrice || 0,
            flexibleComboId: item.flexibleComboId || null,
            merchantId: item.merchantId || 1,
            vouchers: (item.vouchers || []).map((v) => ({
              voucherId: v.voucherId,
              voucherDetailId: v.voucherDetailId,
              voucherCode: v.voucherCode,
              voucherTypeDiscount: v.voucherTypeDiscount,
              voucherAmount: Number(v.voucherAmount),
              contractDetailVoucherId: v.id,
            })),
            warrantyMonthNo: item.warrantyMonthNo || '',
            warrantyPhone: item.warrantyPhone || '',
            warrantyAddress: item.warrantyAddress || '',
            warrantyDescription: item.warrantyDescription || '',
          };
          // SP tặng kèm từ HĐMB → bill item bonus (giá 0), gắn dưới item chính
          // qua belongBillDetailId = id của contract_detail cha.
          const gifts = (item.gifts || []).map((g) => ({
            id: g.id,
            productId: g.productId,
            name: g.product ? g.product.name : g.productName,
            code: g.product ? g.product.code : '',
            price: 0,
            type: g.product ? g.product.type : null,
            quantity: g.quantity,
            productChassisId: g.productChassisId,
            productSerialId: g.productSerialId,
            chassisNumber: g?.productChassis?.chassisNumber || null,
            engineNumber: g?.productChassis?.engineNumber || null,
            serialNumber: g?.productSerial?.serialNumber || null,
            totalPrice: 0,
            totalAmount: 0,
            discount: 0,
            discountAmount: 0,
            billItemType: BILL_ITEM_TYPE.PRODUCT_BONUS,
            checked: true,
            returnPrice: 0,
            belongBillDetailId: item.id,
            quantityInStock: g?.product?.productStock?.length
              ? g.product.productStock[0]['inStockQuantity']
              : 0,
            storeId: dataRes.storeId,
            discountType: g.discountType,
            isGetVat: false,
            sellingPrice: 0,
            merchantId: g.merchantId || 1,
            vouchers: [],
          }));
          // SP bán kèm từ HĐMB → bill item bán kèm (type 3), GIỮ giá, gắn dưới
          // item chính qua belongBillDetailId = id của contract_detail cha.
          const attachs = (item.attachs || []).map((a) => {
            const price = Number(a.productPrice) || 0;
            return {
              id: a.id,
              productId: a.productId,
              name: a.product ? a.product.name : a.productName,
              code: a.product ? a.product.code : '',
              price,
              type: a.product ? a.product.type : null,
              quantity: a.quantity,
              productChassisId: a.productChassisId,
              productSerialId: a.productSerialId,
              chassisNumber: a?.productChassis?.chassisNumber || null,
              engineNumber: a?.productChassis?.engineNumber || null,
              serialNumber: a?.productSerial?.serialNumber || null,
              totalPrice: +a.totalAmount,
              totalAmount: +a.totalAmount,
              discount: Number(a.discountAmount) || 0,
              discountAmount: Number(a.discountAmount) || 0,
              billItemType: BILL_ITEM_TYPE.PRODUCT_PROMTION,
              checked: true,
              returnPrice: 0,
              belongBillDetailId: item.id,
              quantityInStock: a?.product?.productStock?.length
                ? a.product.productStock[0]['inStockQuantity']
                : 0,
              storeId: dataRes.storeId,
              discountType: a.discountType,
              isGetVat: false,
              sellingPrice: price,
              merchantId: a.merchantId || 1,
              vouchers: [],
            };
          });
          return [main, ...gifts, ...attachs];
        });
      });

      setTimeout(() => {
        this.renderComponent = true;
      }, TIME_TRIGGER);

      this.fetchStoreByUser();
    },
    getOrderById() {
      ApiService.query(`orders/${this.mainModel.orderId}`).then((data) => {
        const {
          saleNote,
          customerNote,
          customerId,
          discountAmount,
          discountType,
          transferAmount,
          depositAmount,
          storeId,
          store,
          orderItems,
          orderSourceId,
          creditAmount,
          installedMoneyAmount,
          customerShipFee,
          warrantyNote,
          codeShip,
          saleStoreId,
          saleStoreName,
        } = data.data.data;
        this.mainModel.billNote.warrantyNote = warrantyNote;
        this.mainModel.storeId = storeId;
        this.mainModel.storeName = store.name;
        this.mainModel.billEmployeeInfo.saleId = saleStoreId;
        this.mainModel.billEmployeeInfo.saleName = saleStoreName;
        this.mainModel.billNote.saleNote = saleNote;
        this.mainModel.billNote.customerNote = customerNote;
        this.mainModel.customerModel.customerId = customerId;
        this.mainModel.discountAmount = discountAmount ? discountAmount : 0;
        this.mainModel.discountType = discountType;
        this.searchStore = store.name;
        this.mainModel.orderSourceId = orderSourceId;
        this.mainModel.moneyTransfered = transferAmount;
        this.mainModel.moneyPaid = depositAmount;
        this.mainModel.moneyCredit = creditAmount;
        this.mainModel.moneyInstallment = installedMoneyAmount;
        this.mainModel.codeShip = codeShip;
        this.inputSearchProductProp.disabled = false;
        this.mainModel.customerModel.customerMobile =
          data.data.data.customerMobile;
        this.mainModel.customerModel.customerAddress =
          data.data.data.customerAddress;
        this.mainModel.customerModel.customerName = data.data.data.customerName;
        this.mainModel.customerModel.customerCity = data.data.data.customerCity;
        this.mainModel.customerModel.customerWard = data.data.data.customerWard;
        this.mainModel.customerModel.customerDistrict =
          data.data.data.customerDistrict;
        this.mainModel.vatInvoice.companyAddress =
          data.data.data.vatCompanyAddress;
        this.mainModel.vatInvoice.companyName = data.data.data.vatCompanyName;
        this.mainModel.vatInvoice.taxCode = data.data.data.taxCode;
        this.mainModel.vatInvoice.email = data.data.data.email;
        this.mainModel.couponCode = data.data.data.couponCode;
        this.isValidCoupon = data.data.data.couponCode ? true : false;
        this.mainModel.customerShipFee = customerShipFee ? customerShipFee : 0;
        this.mainModel.customerModel.totalPoint = data.data.data.customerPoint;
        this.mainModel.subtractPoint = data.data.data.subtractPoint;
        this.mainModel.totalAmountPoint = data.data.data.subtractPointAmount;
        this.mainModel.isSubtractPointValidated =
          data.data.data.subtractPointAmount > 0 ? true : false;
        this.listBillItem = orderItems.map((orderItem) => {
          let isGiftTaken = true;
          if (orderItem.isGiftTaken === 0) {
            isGiftTaken = true;
          }
          return {
            id: orderItem.id,
            productId: orderItem.productId,
            name: orderItem.productName,
            code: orderItem.productCode,
            productNameVat: orderItem.productNameVat,
            type: orderItem.productType,
            price: orderItem.productPrice,
            imeiCode: orderItem.imeiCode,
            quantity: orderItem.quantity,
            totalPrice: orderItem.totalAmount,
            discount:
              orderItem.orderItemType === AMOUNT_TYPE.MONEY
                ? orderItem.discountAmount
                : 0,
            discountType: AMOUNT_TYPE.MONEY,
            quantityInStock: orderItem.quantityInStock,
            comboItems: orderItem.productInCombos,
            storeId: storeId,
            deleted: orderItem.deleted,
            billItemType: orderItem.orderItemType,
            returnPrice: orderItem.repurchasePrice
              ? orderItem.repurchasePrice
              : 0,
            checked: isGiftTaken,
            orderItemType: orderItem.orderItemType,
            listAccessoryBonus: [],
            note: orderItem.note ? orderItem.note : '',
            listAccessoryPromotion: orderItem.listAccessoryPromotion
              ? orderItem.listAccessoryPromotion
              : [],
            belongBillDetailId: orderItem.belongOrderDetailId,
            isGetVat: false,
            merchantId: orderItem.merchantId,
          };
        });
        this.listBillItem = this.sortListBillItem(this.listBillItem);
        this.inputSearchProductProp.disabled = false;
        this.renderComponent = true;
      });
    },
    getBillById() {
      ApiService.get(`bills/${this.mainModel.billNumber}`).then(
        async (response) => {
          if (response.data.status === 0) {
            return makeToastFaile('Tải thông tin hóa đơn thất bại!');
          }
          const dataRes = response.data.data;
          const {
            id,
            storeId,
            store,
            siteCode,
            customer,
            saleNote,
            customerNote,
            warrantyNote,
            customerId,
            discountAmount,
            discountCouponCode,
            discountType,
            orderSourceId,
            customerShipFee,
            contractCode,
            contractId,
            codeShip,
            cashAmount,
            cashAccountId,
            cashAccName,
            cashAccountCode,
            transferAmount,
            transferAccountId,
            transferAccName,
            transferAccountCode,
            transferReferenceCode,
            creditAmount,
            creditAccountId,
            creditAccName,
            creditAccountCode,
            creditCardNo,
            creditCode,
            otherFees,
            payCreditFeeType,
            creditFeeAcountId,
            creditFeeAccName,
            creditFeeAcountCode,
            installedMoneyAmount,
            installMoneyAccountId,
            installmentAccName,
            customerIndentifyNo,
            installMoneyCode,
            depositAmount,
            transferFromOrder,
            moneyCredit,
            moneyInstallment,
            pointToMoney,
            subtractPoint,
            billItems,
            editable,
            isSubtractPointValidated,
            isCountPoint,
            payments,
            createdAt,
            tradeIn,
            vatStatus,
            vatRejectReason,
            vatRequestedAt,
            vatApprovedAt,
            totalAmount,
          } = dataRes;

          this.tradeIn = { ...tradeIn };
          this.mainModel.id = id;
          this.mainModel.storeId = storeId;
          this.mainModel.storeName = store.name;
          this.mainModel.siteCode = siteCode;
          this.mainModel.totalAmount = totalAmount;
          this.mainModel.stockSlipId = this.tradeIn.stockSlip
            ? this.tradeIn.stockSlip.id
            : '';
          this.mainModel.billNote.warrantyNote = warrantyNote;
          this.mainModel.billNote.saleNote = saleNote;
          this.mainModel.billNote.customerNote = customerNote;
          this.mainModel.contractId = contractId;
          this.mainModel.contractNumber = contractCode;
          // Hóa đơn tạo từ HĐ mua bán: load tiền cọc/đã thu trên HĐ để đối trừ vào
          // "Khách cần trả" (GET /bills/:id không merge payments của HĐ vào payments[] →
          // phải fetch riêng). Chỉ set moneyPrepaidContract, KHÔNG nhét vào mảng payment.
          this.fetchContractPrepaid(contractId);
          this.mainModel.customerModel.customerId = customerId;
          this.mainModel.customerModel.customerMobile = dataRes.customerPhone;
          this.mainModel.customerModel.customerAddress =
            dataRes.customerAddress;
          this.mainModel.customerModel.customerName = dataRes.customerName;
          this.mainModel.customerModel.customerKind =
            dataRes.customerType || 'CUSTOMER';
          this.mainModel.customerModel.customerMst = dataRes.customerMst || '';
          this.mainModel.customerModel.customerRepresentative =
            dataRes.customerRepresentative || '';
          this.mainModel.customerModel.customerBusinessId =
            dataRes.customerBusinessId || null;
          // this.mainModel.customerModel.customerCity = dataRes.customerCity;
          // this.mainModel.customerModel.customerWard = dataRes.customerWard;
          // this.mainModel.customerModel.customerDistrict =
          //   dataRes.customerDistrict;
          // this.mainModel.customerModel.totalPoint = dataRes.customerPoint;
          this.mainModel.customerModel.customerAppellation = customer
            ? customer.gender
            : null;
          this.mainModel.orderSourceId = orderSourceId;
          this.mainModel.discountAmount = discountAmount ? discountAmount : 0;
          this.mainModel.discountType = discountType;
          this.mainModel.codeShip = codeShip;
          this.mainModel.customerShipFee = customerShipFee
            ? customerShipFee
            : 0;
          this.mainModel.billEmployeeInfo.saleId = dataRes.saleId;
          this.mainModel.billEmployeeInfo.saleName = dataRes.saleName;
          this.mainModel.billEmployeeInfo.technicalId = dataRes.technicalId;
          this.mainModel.billEmployeeInfo.technicalName = dataRes.technicalName;
          this.mainModel.billEmployeeInfo.cashierId = dataRes.cashierId;
          this.mainModel.billEmployeeInfo.cashierName = dataRes.cashierName;
          this.mainModel.billEmployeeInfo.managerId = dataRes.managerId;
          this.mainModel.billEmployeeInfo.managerName = dataRes.managerName;
          this.mainModel.billEmployeeInfo.assistantId = dataRes.assistantId;
          this.mainModel.billEmployeeInfo.assistantName = dataRes.assistantName;
          this.mainModel.billEmployeeInfo.customerReceptionId =
            dataRes.receptionId;
          this.mainModel.billEmployeeInfo.customerReceptionName =
            dataRes.receptionName;
          this.mainModel.billEmployeeInfo.accessoryStaffId =
            dataRes.accessoryStaffId;
          this.mainModel.billEmployeeInfo.accessoryStaffName =
            dataRes.accessoryStaffName;
          this.mainModel.billEmployeeInfo.shipperId = dataRes.shipperId;
          this.mainModel.billEmployeeInfo.shipperName = dataRes.shipperName;
          this.mainModel.vatStatus = vatStatus || null;
          this.mainModel.vatRejectReason = vatRejectReason || null;
          this.mainModel.vatRequestedAt = vatRequestedAt || null;
          this.mainModel.vatApprovedAt = vatApprovedAt || null;
          this.mainModel.paymentInfo.cashAmount = +cashAmount;
          this.mainModel.paymentInfo.cashAccountId = cashAccountId;
          this.mainModel.paymentInfo.cashAccountantName = cashAccName;
          this.mainModel.paymentInfo.cashAccountCode = cashAccountCode;
          this.mainModel.paymentInfo.transferAmount = transferAmount;
          this.mainModel.paymentInfo.transferAccountantId = transferAccountId;
          this.mainModel.paymentInfo.transferAccountantName = transferAccName;
          this.mainModel.paymentInfo.transferAccountCode = transferAccountCode;
          this.mainModel.paymentInfo.transferReferenceCode =
            transferReferenceCode;
          this.mainModel.paymentInfo.creditAmount = creditAmount;
          this.mainModel.paymentInfo.creditAccountantId = creditAccountId;
          this.mainModel.paymentInfo.creditAccountCode = creditAccountCode;
          this.mainModel.paymentInfo.creditAccountantName = creditAccName;
          this.mainModel.paymentInfo.creditCardNo = creditCode;
          this.mainModel.paymentInfo.creditCardCode = creditCardNo;
          this.mainModel.paymentInfo.creditCardFee = otherFees;
          this.mainModel.paymentInfo.payCreditFeeType = payCreditFeeType;
          this.mainModel.paymentInfo.creditFeeAccountantId = creditFeeAcountId;
          this.mainModel.paymentInfo.creditFeeAcountCode = creditFeeAcountCode;
          this.mainModel.paymentInfo.creditFeeAccountantName = creditFeeAccName;
          this.mainModel.paymentInfo.installedMoneyAmount =
            installedMoneyAmount;
          this.mainModel.paymentInfo.installMoneyAccountId =
            installMoneyAccountId;
          this.mainModel.paymentInfo.installmentAccountName =
            installmentAccName;
          this.mainModel.paymentInfo.customerIndentifyNo = customerIndentifyNo;
          this.mainModel.paymentInfo.installmentCode = installMoneyCode;
          this.mainModel.warrantyCustomerModel.customerId =
            dataRes.warrantyCustomerId;
          this.mainModel.warrantyCustomerModel.customerName =
            dataRes.warrantyCustomerName;
          this.mainModel.warrantyCustomerModel.customerMobile =
            dataRes.warrantyCustomerPhone;
          this.mainModel.warrantyCustomerModel.customerLastName =
            dataRes.warrantyCustomerLastName;
          this.mainModel.orderId = dataRes.orderId;
          this.mainModel.moneyTransfered = transferFromOrder || 0;
          this.mainModel.moneyPaid = depositAmount || 0;
          this.mainModel.moneyCredit = moneyCredit || 0;
          this.mainModel.moneyInstallment = moneyInstallment || 0;
          this.mainModel.totalAmountPoint = pointToMoney;
          this.mainModel.subtractPoint = subtractPoint;
          this.prevSubtractPoint = subtractPoint;
          this.mainModel.isSubtractPointValidated = isSubtractPointValidated;
          this.mainModel.isCountPoint = isCountPoint;
          this.mainModel.couponCode = discountCouponCode;
          this.prevCouponCode = discountCouponCode;
          this.mainModel.vatInvoice.companyName = dataRes.companyName;
          this.mainModel.vatInvoice.companyAddress = dataRes.vatCompanyAddress;
          this.mainModel.vatInvoice.vatCompanyType = dataRes.vatCompanyType;
          this.mainModel.vatInvoice.email = dataRes.email;
          this.mainModel.vatInvoice.taxCode = dataRes.taxCode;
          this.mainModel.companyBill = dataRes.taxCode ? true : false;
          this.mainModel.billNote.customerNote = dataRes.customerNote;
          this.mainModel.billNote.saleNote = dataRes.saleNote;
          this.mainModel.billNote.warrantyNote = dataRes.warrantyNote;
          this.mainModel.editable = editable;
          this.mainModel.billCreatedAt = createdAt;
          this.mockupCustomerForBill.customerId = dataRes.customerId;
          this.mockupCustomerForBill.customerName = dataRes.customerName;
          this.mainModel.installments = payments.filter(
            (item) => item.type === PAYMENT_TYPE.INSTALLMENT,
          );
          this.mainModel.credits = payments.filter(
            (item) => item.type === PAYMENT_TYPE.CREDIT,
          );
          this.mainModel.transfer = payments.filter(
            (item) => item.type === PAYMENT_TYPE.TRANSFER,
          );
          this.mainModel.cash = payments.filter(
            (item) => item.type === PAYMENT_TYPE.CASH,
          );

          this.mainModel.refunds = payments.filter(
            (item) => item.type === PAYMENT_TYPE.REFUND,
          );
          const flexibleComboBillItems = billItems.filter(
            (billItem) => billItem.flexibleComboId,
          );
          const normalBillItems = billItems.filter(
            (billItem) => !billItem.flexibleComboId,
          );
          const flexibleComboItems = this.combineFlexibleCombo(
            flexibleComboBillItems,
          );
          this.isInterestZero = dataRes.isInterestZero;
          this.$store.dispatch(SET_INTEREST, dataRes.isInterestZero);
          if (dataRes.installmentProgram) {
            await this.$nextTick();
            this.$store.dispatch(SET_INSTALLMENT_PROGRAM, {
              details: [],
              installmentProgramId: dataRes.installmentProgram.id,
              installmentProgramName: dataRes.installmentProgram.name,
              installmentProgramMonthNo: dataRes.installmentProgramMonthNo,
              installmentProgramPrepayPercent:
                dataRes.installmentProgramPrepayPercent,
              monthNo: dataRes.installmentProgram.monthNo,
              prepayPercent: dataRes.installmentProgram.prepayPercent,
              conversionFeePercent:
                dataRes.installmentProgram.conversionFeePercent,
            });
          }
          this.listBillItem = normalBillItems.map((billItem) => {
            return {
              id: billItem.id,
              productId: billItem.productId,
              categoryId: billItem?.product?.categoryId,
              discountAllocation: billItem.discountAllocation,
              name: billItem.product.name,
              productNameVat: billItem.productNameVat,
              code: billItem.product.code,
              price: billItem.productPrice,
              type: billItem.product.type,
              quantity: billItem.quantity,
              //todo
              // imeiCode: billItem.imeiCode,
              productChassisId: billItem.productChassisId,
              productSerialId: billItem.productSerialId,

              chassisNumber: billItem.chassisNumber || null,
              engineNumber: billItem.engineNumber || null,
              serialNumber: billItem.serialNumber || null,
              totalPrice: +billItem.totalAmount,
              totalAmount: +billItem.totalAmount,
              importPrice: +billItem.importPrice,
              discount: Number(billItem.discountAmount) || 0,
              discountAmount: Number(billItem.discountAmount) || 0,
              comboItems: billItem.listProductInCombo,
              returnPrice: billItem.repurchasePrice
                ? billItem.repurchasePrice
                : 0,
              accessoryGroupId: billItem.accessoryGroupId
                ? billItem.accessoryGroupId
                : '',
              accessoryGroupCode: billItem.accessoryGroupCode
                ? billItem.accessoryGroupCode
                : '',
              note: billItem.note,
              belongBillDetailId: billItem.belongBillDetailId,
              listAccessoryPromotion: billItem.listProductPromotion,
              quantityInStock: billItem.quantityInStock,
              storeId: storeId,
              discountType: billItem.discountType,
              discountProgramId: billItem.discountProgramId,
              isGetVat: billItem.issuedVat === 1 ? true : false,
              disabledByInstallmentProgram: this.applyInstallmentProgram
                ? true
                : false,
              isInstallmentProgramProduct: this.applyInstallmentProgram
                ? true
                : false,
              sellingPrice: billItem.sellingPrice || 0,
              listedPrice: billItem.listedPrice || 0,
              flexibleComboId: billItem.flexibleComboId || null,
              merchantId: billItem.merchantId || 1,
              vouchers: billItem.vouchers || [],
              warrantyMonthNo: billItem.warrantyMonthNo || '',
              warrantyPhone: billItem.warrantyPhone || '',
              warrantyAddress: billItem.warrantyAddress || '',
              warrantyDescription: billItem.warrantyDescription || '',
              billItemType: billItem.type || BILL_ITEM_TYPE.PRODUCT,
              checked: billItem.isGiftTaken,
            };
          });
          this.listBillItem = this.listBillItem.concat(flexibleComboItems);
          this.listBillItem = this.sortListBillItem(this.listBillItem);
          this.inputSearchProductProp.disabled = false;
          if (this.$route.name === 'add-bill') {
            this.mainModel.id = null;
            this.mainModel.billNumber = null;
            this.mainModel.storeDisable = true;
          } else {
            this.pageTitle = `#${
              this.mainModel.billNumber
            } - Ngày: ${this.formatDate(dataRes.createdAt)}`;
          }
          setTimeout(() => {
            this.renderComponent = true;
          }, TIME_TRIGGER);

          this.fetchStoreByUser();
          // if (this.mainModel.contractId) {
          //   this.getContractById();
          // }
        },
      );
    },
    checkPermission: function (condition) {
      return localData.checkPermission(condition);
    },
    openFileUpload() {
      document.getElementById('upload-files').click();
    },
    handleFileUpload(event) {
      // this.linkHref = "";
      this.fileAttach.files = event.target.files;
    },
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    //This is where we implement the storage service
    save(formData) {
      this.currentStatus = STATUS_SAVING;
      //Implement your own storage service when upload() is called.
      //For test purposes, I added a delay service
      this.upload(formData)
        .then((x) => {
          this.uploadedFiles = this.uploadedFiles.concat(x);
          this.currentStatus = STATUS_SUCCESS;
        })
        .catch((err) => {
          this.uploadError = err.response;
          this.currentStatus = STATUS_FAILED;
        });
    },
    upload(formData) {
      const photos = formData.getAll('photos');
      const promises = photos.map((x) =>
        this.getImage(x).then((img) => ({
          id: img,
          originalName: x.name,
          fileName: x.name,
          url: img,
        })),
      );
      return Promise.all(promises);
    },
    getImage(file) {
      return new Promise((resolve) => {
        const fReader = new FileReader();
        const img = document.createElement('img');

        fReader.onload = () => {
          img.src = fReader.result;
          resolve(this.getBase64Image(img));
        };

        fReader.readAsDataURL(file);
      });
    },
    getBase64Image(img) {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const dataURL = img.src;
      return dataURL;
    },
    //Returns true for image data types for others false, for preview purpose
    typecheck(oInput) {
      var _validFileExtensions = ['.jpg', '.jpeg', '.bmp', '.gif', '.png'];
      if (oInput.length > 0) {
        var blnValid = false;
        for (var j = 0; j < _validFileExtensions.length; j++) {
          var sCurExtension = _validFileExtensions[j];
          if (
            oInput
              .substr(
                oInput.length - sCurExtension.length,
                sCurExtension.length,
              )
              .toLowerCase() == sCurExtension.toLowerCase()
          ) {
            blnValid = true;
            break;
          }
        }
        if (!blnValid) {
          return false;
        }
      }
      return true;
    },
    //Removes the selected file from the array.
    removeFile(fileCount, key) {
      fileCount = this.uploadedFiles.length;
      if (fileCount === 1) {
        this.uploadedFiles.splice(key, 1);
        this.reset();
      } else {
        this.uploadedFiles.splice(key, 1);
      }
    },
    //Func to truncate long filenames to short ones to display
    ftruncate(n) {
      // var len = 10;
      var ext = n.substring(n.lastIndexOf('.') + 1, n.length).toLowerCase();
      var filename = n.replace('.' + ext, '');
      return filename + '.' + ext;
    },
    // Handle file changes
    filesChange(fieldName, fileList) {
      const formData = new FormData();
      if (!fileList.length) return;
      Array.from(Array(fileList.length).keys()).map((x) => {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });
      this.save(formData);
    },
    submitFileUpload() {
      let formData = new FormData();

      for (const i of Object.keys(this.fileAttach.files)) {
        formData.append('files', this.fileAttach.files[i]);
      }
      formData.append('entity', UPLOAD_ENTITY.BILLS);
      formData.append('entityId', this.mainModel.billNumber);

      this.currentStatus = STATUS_SAVING;
      const context = this;

      axios
        .post(`${cmdUrl.FileBills.upload}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${JwtService.getToken()}`,
            'device-type': '2',
          },
        })
        .then((resp) => {
          if (resp.data.status === 1) {
            context.currentStatus = STATUS_SUCCESS;
            makeToastSuccess('Tải tệp lên thành công!');
            context.loadAttachments();
          }
        })
        .catch(() => {
          context.currentStatus = STATUS_FAILED;
          makeToastFaile('Tải tệp lên thất bại!');
        });
    },
    deleteAttachment(id) {
      ApiService.delete(`${cmdUrl.FileBills.root}/${id}`)
        .then((deleteResponse) => {
          if (deleteResponse.data.status === 1) {
            this.loadAttachments();
            makeToastSuccess('Xóa tệp thành công!');
          } else {
            makeToastFaile('Xóa tệp thất bại!');
          }
        })
        .catch(() => {
          makeToastFaile('Xóa tệp thất bại!');
        });
    },
    loadAttachments() {
      this.isLoadAttachmentSuccess = false;

      ApiService.query('files-bill', {
        params: {
          entity: UPLOAD_ENTITY.BILLS,
          entityId: this.mainModel.billNumber,
        },
      })
        .then(async (resp) => {
          if (resp.data.status === 1) {
            const attachments = resp.data.data.map((item) => ({
              id: item.id,
              fileName: item.fileName,
              originalName: item.name,
              path: item.path,
            }));
            if (!attachments || attachments.length === 0) {
              this.attachments = [];
              this.isLoadAttachmentSuccess = true;
              return;
            }
            this.attachments = await Promise.all(
              attachments.map(async (attachment) => {
                try {
                  const response = await axios.get(
                    `${cmdUrl.FileBills.preview}`,
                    {
                      params: {
                        fileName: attachment.fileName,
                        entity: UPLOAD_ENTITY.BILLS,
                        entityId: this.mainModel.billNumber,
                      },
                      headers: {
                        'device-type': '2',
                      },
                      responseType: 'blob',
                    },
                  );
                  const blob = new Blob([response.data], {
                    type: response.headers['content-type'],
                  });
                  const url = URL.createObjectURL(blob);

                  return {
                    ...attachment,
                    url: url,
                  };
                } catch (error) {
                  console.error('Error loading image:', error);
                  return {
                    ...attachment,
                    url: '',
                  };
                }
              }),
            );
            this.isLoadAttachmentSuccess = true;
          }
        })
        .catch((error) => {
          console.error('Error loading attachments:', error);
          this.isLoadAttachmentSuccess = false;
        });
    },
    handleHidePreviewFile() {
      this.previewFile.visible = false;
    },
    showMultiplePreViewFile(indexOfFile) {
      const files = this.uploadedFiles.map((file) => {
        return {
          src: file.url,
          title: file.fileName,
        };
      });
      this.previewFile.imgs = files;
      this.previewFile.index = indexOfFile;
      this.previewFile.visible = true;
    },
    handleHidePreviewAttachment() {
      this.previewAttachment.visible = false;
    },
    showMultiplePreViewAttachment(indexOfFile) {
      const files = this.attachments.map((file) => {
        return {
          src: file.url,
          title: file.fileName,
        };
      });
      this.previewAttachment.imgs = files;
      this.previewAttachment.index = indexOfFile;
      this.previewAttachment.visible = true;
    },
    viewHistoryDetail(item) {
      const { href } = this.$router.resolve({
        name: 'detail-bill-history',
        query: { id: item.id },
      });
      window.open(href, '_blank');
    },
    fetchBillHistory: async function () {
      // const params = {
      //   //  loại hóa đơn
      //   type: 2,
      // };
      await ApiService.setHeader();
      await ApiService.query(
        `bills/${this.mainModel.billNumber}/histories`,
      ).then((res) => {
        res.data.data.map((x) => {
          let data = {
            id: x.id,
            // type: x.type,
            // referenceId: x.referenceId,
            // action: x.action,
            // description: x.description,
            // originalValue: x.originalValue,
            // newValue: x.newValue,
            updatedBy: x.userCreated.fullName,
            createdAt: moment(String(x.createdAt)).format('DD/MM/YYYY HH:mm'),
            updatedAt: moment(x.updatedAt).format('DD/MM HH:mm'),
          };
          this.histories.push(data);
        });
      });
    },
    onUpdatePayment(paymentInfo) {
      this.mainModel.paymentInfo = cloneDeep(paymentInfo);
    },
    onUpdatePaymentV2(items = [], type) {
      const payments = items.reduce((result, current) => {
        result.push({
          ...current,
          paymentAmount: unMaskPrice(current.amount),
        });
        return result;
      }, []);
      switch (type) {
        case PAYMENT_TYPE.INSTALLMENT: {
          this.mainModel.installments = payments;
          break;
        }
        case PAYMENT_TYPE.CREDIT: {
          this.mainModel.credits = payments;
          break;
        }
        case PAYMENT_TYPE.TRANSFER: {
          this.mainModel.transfer = payments;
          break;
        }
        case PAYMENT_TYPE.CASH: {
          this.mainModel.cash = payments;
          break;
        }
        case PAYMENT_TYPE.REFUND: {
          this.mainModel.refunds = payments;
          break;
        }
      }
    },
    onUpdateCustomer(customerInfo) {
      this.mainModel.customerModel = cloneDeep(customerInfo);
      if (
        this.mainModel.id &&
        customerInfo.customerId !== this.mockupCustomerForBill.customerId
      ) {
        this.mainModel.customerModel.customerId =
          this.mockupCustomerForBill.customerId;
      }
    },
    /**
     * PUT /customers — persist field pháp lý KH (CCCD/Email/Ngày sinh) khi lưu bill.
     * Field do component CustomerInfo emit về `customerModel`. Fetch customer hiện tại
     * để merge full body (DTO yêu cầu fullName/phoneNumber/...). Không block lưu bill.
     */
    async persistBillCustomerLegal() {
      const cm = this.mainModel.customerModel || {};
      if (!cm.customerId) return;
      // Nếu component không bind field pháp lý (chưa nhập gì) → bỏ qua.
      const hasLegal =
        cm.customerCccdNo ||
        cm.customerCccdDate ||
        cm.customerCccdPlace ||
        cm.customerEmail ||
        cm.customerDob;
      if (!hasLegal) return;
      const toBe = (v) => {
        if (!v) return null;
        const m = moment(
          v,
          ['YYYY-MM-DD', 'DD/MM/YYYY', moment.ISO_8601],
          true,
        );
        const m2 = m.isValid() ? m : moment(v);
        return m2.isValid() ? m2.format('YYYY-MM-DD') : null;
      };
      try {
        const res = await ApiService.get(`customers/${cm.customerId}`);
        const snap = (res && res.data && (res.data.data || res.data)) || {};
        const data = {
          id: cm.customerId,
          fullName: snap.fullName || cm.customerName || '',
          phoneNumber: snap.phoneNumber || cm.customerMobile || '',
          gender: cm.customerAppellation || snap.gender || 'OTHER',
          dateOfBirth:
            toBe(cm.customerDob) ||
            (snap.dateOfBirth
              ? moment(snap.dateOfBirth).format('YYYY-MM-DD')
              : null),
          address: cm.customerAddress || snap.address || '',
          note: snap.note || '',
          deleted: snap.deleted ? 1 : 0,
          cccdNo: (cm.customerCccdNo || '').trim(),
          cccdDate: toBe(cm.customerCccdDate),
          cccdPlace: (cm.customerCccdPlace || '').trim(),
        };
        const emailVal = (cm.customerEmail || snap.email || '').trim();
        if (emailVal) data.email = emailVal;
        await ApiService.put('customers', data);
      } catch (e) {
        // ignore — không block lưu bill
      }
    },
    onChangeSubtractPoint() {
      if (this.prevSubtractPoint !== this.mainModel.subtractPoint) {
        this.mainModel.isSubtractPointValidated = false;
      } else {
        this.mainModel.isSubtractPointValidated = true;
      }
    },
    fetchStoreByUser() {
      ApiService.get(`stores/get-by-user`).then(({ data }) => {
        if (data.status === 1) {
          this.inputSearchProductProp.disabled = false;
          if (!this.mainModel.billEmployeeInfo.saleId) {
            this.mainModel.billEmployeeInfo.saleId = data.data.id;
            this.mainModel.billEmployeeInfo.saleName = data.data.employeeName;
          }

          if (
            data.data.jobTitleId === 6 &&
            !this.mainModel.billEmployeeInfo.cashierId
          ) {
            this.mainModel.billEmployeeInfo.cashierId = data.data.id;
            this.mainModel.billEmployeeInfo.cashierName =
              data.data.employeeName;
          }
          const stores = data.data.stores;
          if (stores.length === 1 && !this.mainModel.storeId) {
            this.mainModel.storeId = stores[0].id;
            this.mainModel.storeName = stores[0].name;
            this.mainModel.storeDisable = false;
            // this.fetchShiftWorkConfig();
          }
          if (this.mainModel.id) {
            // this.fetchShiftWorkConfig();
            this.mainModel.storeDisable = true;
          }
        }
      });
    },
    fetchCustomerCransaction(customerTransaction) {
      this.orderNotComplete = customerTransaction.orderNotComplete;
    },
    showWarningOrderNotComplete: function (billData) {
      Swal.fire({
        title: 'Cảnh báo đơn hàng!',
        text: 'Khách hàng có đơn hàng chưa hoàn thành, bạn có chắc muốn tạo hóa đơn mới cho khách hàng này không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Tạo mới',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
        position: 'top',
      }).then((result) => {
        if (result.value) {
          this.onCallApiCreate(billData);
        } else {
          this.onSubmiting = false;
        }
      });
    },
    linkToWarranty(id) {
      this.$router.push({
        name: 'add-import-warranty',
        query: { refId: id },
      });
    },
    showActiveModal(imeiCode) {
      this.$refs['active-imei-modal'].showModal(
        imeiCode,
        this.mainModel.customerModel.customerMobile,
        this.mainModel.storeName,
        this.mainModel.siteCode,
      );
    },
    // fetchProgramByProductIds(isInterestZero) {
    //   const items = cloneDeep(this.listBillItem);
    //   const productIds = items.map((item) => item.productId);
    //   if (!productIds.length) {
    //     return;
    //   }
    //   const params = {
    //     productIds: productIds,
    //     isInterestZero: isInterestZero,
    //   };
    //   ApiService.query('installment-programs/product-ids', {
    //     params: params,
    //   }).then((response) => {
    //     const { data } = response.data;
    //     let programs = [];
    //     items.map((item, index) => {
    //       const productFinded = data.find(
    //         (product) => product.productId === item.productId,
    //       );
    //       if (productFinded) {
    //         item.sellingPrice = productFinded.programPrice;
    //         item.price = productFinded.programPrice;
    //         programs = programs.concat(productFinded.programs);
    //         this.$set(this.listBillItem, index, item);
    //       }
    //     });
    //     this.selectInstallmentProgram(isInterestZero, programs);
    //   });
    // },
    selectInstallmentProgram(isInterestZero, programs) {
      if (isInterestZero) {
        const firstChoiceProram = programs[0];
        if (firstChoiceProram) {
          this.$store.dispatch(SET_INSTALLMENT_PROGRAM, {
            installmentProgramId: firstChoiceProram.id,
            installmentProgramName: firstChoiceProram.name,
            monthNo: firstChoiceProram.monthNo,
            installmentProgramMonthNo: null,
            installmentProgramPrepayPercent: null,
            prepayPercent: firstChoiceProram.prepayPercent,
            conversionFeePercent: firstChoiceProram.conversionFeePercent,
            details: programs,
          });
        }
      } else {
        this.$store.dispatch(PURGE_INSTALLMENT_PROGRAM);
      }
    },
    onShowInterestProgram() {
      this.$refs['bill-payment'].onLoading.interestZero = true;
      this.$nextTick(() => {
        EventBus.$emit('popup-insterest-program');
      });
    },
    searchFlexibleCombo(textSearch) {
      const params = {
        textSearch: textSearch,
        storeId: this.mainModel.storeId,
      };
      ApiService.query('flexible-combo/search', { params }).then(({ data }) => {
        const products = data.data;
        this.optionsProduct[0].data = products.map((product) =>
          Object.assign({}, new FlexibleComboSearchOption(product)),
        );
        this.filteredOptionsProduct = [
          {
            data: this.optionsProduct[0].data,
          },
        ];
        this.isSearching = false;
        this.productLoading = false;
      });
    },
    showModalFlexibleCombo() {
      setTimeout(() => {
        this.$refs['flexible-combo'].showModal();
      }, TIME_TRIGGER);
    },
    addComboChild(billItem) {
      billItem.id = v4();
      this.listBillItem.push(billItem);
      this.sortListBillItem(this.listBillItem);
    },
    combineFlexibleCombo(billItems) {
      const flexibleComboIds = uniq(
        billItems.map(
          (flexibleComboBillItem) => flexibleComboBillItem.flexibleComboId,
        ),
      );
      return flexibleComboIds.map((flexibleComboId) => {
        const flexibleComboItems = billItems.filter(
          (billItem) => billItem.flexibleComboId === flexibleComboId,
        );
        let comboName = '';
        if (flexibleComboItems.length) {
          comboName = flexibleComboItems[0].flexibleComboName;
        }
        const comboItems = flexibleComboItems.map((flexibleComboItem) => {
          return {
            id: flexibleComboItem.id,
            productCode: flexibleComboItem.productCode
              ? flexibleComboItem.productCode
              : '',
            productName: flexibleComboItem.productName
              ? flexibleComboItem.productName
              : '',
            quantity: flexibleComboItem.quantity,
            productId: flexibleComboItem.productId,
            productPrice: flexibleComboItem.productPrice
              ? flexibleComboItem.productPrice
              : 0,
            sellingPrice: flexibleComboItem.productPrice
              ? flexibleComboItem.productPrice
              : 0,
            productType: PRODUCT_TYPE.PRODUCT,
            discountAmount: flexibleComboItem.discountAmount,
            productComboPrice: 0,
            productComboRate: 0,
            productVatAmount: flexibleComboItem.productVatAmount,
            productNameVat: flexibleComboItem.productNameVat
              ? flexibleComboItem.productNameVat
              : '',
            listedPrice: flexibleComboItem.productPrice
              ? flexibleComboItem.productPrice
              : 0,
          };
        });
        const flexibleComboPrice = comboItems.reduce((result, product) => {
          result +=
            product.productPrice * product.quantity - product.discountAmount;
          return result;
        }, 0);
        return {
          id: flexibleComboId,
          productId: flexibleComboId,
          name: comboName,
          code: '',
          productNameVat: '',
          productNote: '',
          productType: PRODUCT_TYPE.PRODUCT_COMBO,
          quantity: 1,
          productPrice: flexibleComboPrice,
          imeiCode: '',
          totalPrice: flexibleComboPrice,
          discount: 0,
          discountType: AMOUNT_TYPE.PERCENT,
          comboItems: comboItems,
          billItemType: BILL_ITEM_TYPE.PRODUCT,
          checked: true,
          accessoryGroupId: null,
          accessoryGroupCode: '',
          repurchasePrice: 0,
          belongBillDetailId: null,
          note: '',
          listAccessoryPromotion: [],
          listProductPromotion: [],
          issuedVat: true,
          sellingPrice: flexibleComboPrice,
          price: flexibleComboPrice,
          listedPrice: flexibleComboPrice,
          flexibleComboId: flexibleComboId,
        };
      });
    },
    showAddVoucherModal(billItemId) {
      const billItem = this.listBillItem.find((item) => item.id === billItemId);
      this.selectedBillItem.productName = billItem ? billItem.name : '';
      this.selectedBillItem.productId = billItem.productId;
      this.selectedBillItem.productAmount = billItem.price;
      this.selectedBillItem.billItemId = billItemId;
      setTimeout(() => {
        this.$refs['apply-voucher-modal'].showModal();
      }, TIME_TRIGGER);
    },
    onApplyVoucherItem(voucherItem) {
      this.calVoucherCumluativeValue(voucherItem);
      this.$forceUpdate();
    },
    calVoucherCumluativeValue(voucherItem) {
      const billItemSelected = this.listBillItem.find(
        (billItem) => billItem.id === this.selectedBillItem.billItemId,
      );

      if (!billItemSelected.vouchers) {
        billItemSelected.vouchers = [];
      }

      if (billItemSelected.vouchers.length > 4) {
        makeToastFaile('Không thể áp dụng trên 5 voucher cho 1 sản phẩm');
        return;
      }

      const validateVoucherExit = billItemSelected.vouchers.some(
        (voucher) => voucher.voucherId === voucherItem.voucherId,
      );
      if (validateVoucherExit) {
        makeToastFaile('Voucher đã được áp dụng cho sản phẩm');
        return;
      }

      billItemSelected.vouchers.push({
        voucherId: voucherItem.voucherId,
        voucherTypeDiscount: DISCOUNT_AMOUNT_TYPE.MONEY,
        voucherAmount: voucherItem.voucherValue,
        voucherCode: voucherItem.voucherCode,
        voucherDetailId: voucherItem.voucherDetailId,
        cumluativeValues: voucherItem.cumluativeValues,
      });

      billItemSelected.discountType = DISCOUNT_AMOUNT_TYPE.MONEY;

      billItemSelected.discountAmount =
        Number(unMaskPrice(billItemSelected.discountAmount)) +
        Number(unMaskPrice(voucherItem.voucherValue));

      billItemSelected.discount =
        Number(unMaskPrice(billItemSelected.discount)) +
        Number(unMaskPrice(voucherItem.voucherValue));
    },
    calVoucherValue(voucherType, voucherValue, productAmount) {
      if (voucherType === DISCOUNT_AMOUNT_TYPE.MONEY) {
        return voucherValue;
      }
      return (productAmount * voucherValue) / 100;
    },
    reCalVoucherBillItem(voucherItem) {
      const billItemVouchers = this.listBillItem.filter(
        (billItem) => billItem.voucherId === voucherItem.voucherId,
      );
      const billItems = billItemVouchers.map((billItem) => {
        return {
          ...billItem,
          quantity: Number(billItem.quantity),
        };
      });
      const totalQuantity = sumBy(billItems, 'quantity');
      const cumluativeValueFound = voucherItem.cumluativeValues.find(
        (cumluativeValue) =>
          cumluativeValue.quantityFrom <= totalQuantity &&
          totalQuantity <= cumluativeValue.quantityTo,
      );
      const voucherCumluativeValue = cumluativeValueFound
        ? cumluativeValueFound.cumulativeValue
        : 0;
      for (const billItemVoucher of billItemVouchers) {
        billItemVoucher.discountAmount =
          this.calVoucherValue(
            DISCOUNT_AMOUNT_TYPE.PERCENT,
            voucherCumluativeValue,
            billItemVoucher.price,
          ) * billItemVoucher.quantity;
        billItemVoucher.discount =
          this.calVoucherValue(
            DISCOUNT_AMOUNT_TYPE.PERCENT,
            voucherCumluativeValue,
            billItemVoucher.price,
          ) * billItemVoucher.quantity;
        billItemVoucher.discountType = DISCOUNT_AMOUNT_TYPE.MONEY;
        billItemVoucher.voucherCumluativeValues = voucherItem.cumluativeValues;
      }
    },
  },
};
</script>

<style>
.autosuggest__results {
  position: absolute;
  width: 100%;
  max-height: 200px;
  border: 1px solid #e0e0e0;
  overflow-y: scroll;
  overflow-x: hidden;
  background-color: #fff;
}

.autosuggest__results-container {
  position: relative;
  font-weight: 500;
  width: 100%;
}

.autosuggest__input {
  display: block;
  width: 100%;
  height: calc(1.35em + 1.1rem + 2px);
  line-height: 1.35;
  padding: 0.55rem 0.75rem;
  font-weight: 400;
  font-size: 0.925rem;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.28rem;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

.autosuggest__input:focus {
  outline: none !important;
  border: 1px solid #92c5f9;
}

.autosuggest__results-item:hover {
  background-color: #ddd;
}

.autosuggest__results ul li {
  padding: 5px 8px 5px 8px;
}

::-webkit-scrollbar {
  width: 13px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #d6dee1;
  border-radius: 20px;
  border: 3px solid transparent;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #a8bbbf;
}
</style>

<style lang="scss">
.bill-info {
  .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
    flex: 0 0 calc(15% - 0.25rem);
  }

  @media (max-width: 1399.98px) {
    .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
      flex: 0 0 calc(17% - 0.25rem);
    }
  }

  .wizard-nav-bg {
    background-color: #f7f7f7;
    border-radius: 5px 5px 0px 0px;
  }

  .alert-header {
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffeeba;
  }

  .box {
    background: black;
    border-radius: 4px;
    padding-bottom: 100%;
  }

  .headerTable {
    color: rgb(24, 28, 50);
    text-align: center;
  }

  .form-group label {
    font-weight: 500;
  }

  .textExcessCash {
    font-weight: 500;
    color: rgba(71, 71, 255, 0.87);
  }

  .row-center-vertical {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .textPoint {
    font-size: 14px;
    font-weight: 500;
  }

  .textFinal {
    font-weight: 500;
    color: brown;
  }

  .textTitlePayment {
    font-weight: 500;
    font-size: 14px;
  }

  .textPayment {
    font-size: 16px;
    font-weight: 500;
    color: brown;
  }

  .no-side {
    padding-left: 0px;
    padding-right: 0px;
  }

  .dropdown-custom {
    .btn-sm,
    .btn-group-sm > .btn {
      padding: 1px 2px;
      background-color: transparent;
      border: none;
      border-radius: 3px;
    }
  }
}
</style>

<style lang="scss">
@import '@/assets/sass/pages/wizard/wizard-4.scss';
</style>

<style lang="scss">
.upload-file {
  table {
    table-layout: fixed;
  }

  .dropbox {
    margin: auto;
    width: 70%;
    background: #f8f8f8;
    border-radius: 20px;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px;
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    left: 0px;
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: #e8f5e9;
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }

  .img-container {
    position: relative;
    display: inline-block;
    width: 80px;
    margin: 0px 10px;
  }

  .preview-img {
    max-width: 80px;
    padding: 10px;
    object-fit: contain;
    border: 1px solid #eeecff;
    border-radius: 5px;
  }

  .preview-img-container {
    border: 2px dashed #eeecff;
    padding: 2rem 1rem;
  }

  .preview-box {
    display: inline-block;
  }

  .close {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 15px;
  }

  .remove {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 15px;
  }

  .cancel {
    color: #545454;
    text-decoration: none;
  }
}

// Pill trạng thái xuất hóa đơn VAT (bvat = bill-vat)
$bvat-pending: #f59e0b;
$bvat-pending-bg: #fff7e6;
$bvat-requested: #6366f1;
$bvat-requested-bg: #eef0ff;
$bvat-issued: #10b981;
$bvat-issued-bg: #e7f8f1;

.bvat-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 100px;
  font-size: 11.5px;
  font-weight: 600;
  i {
    font-size: 10px;
    color: inherit !important;
  }
  &--pending {
    background: $bvat-pending-bg;
    color: $bvat-pending;
  }
  &--requested {
    background: $bvat-requested-bg;
    color: $bvat-requested;
  }
  &--issued {
    background: $bvat-issued-bg;
    color: $bvat-issued;
  }
}
.bvat-reject-note {
  font-size: 12px;
  color: #64748b;
}
</style>
